<template>
    <div class="py-44">
        <div class="container">
            <h1 class="font-display">{{ $t('footer.imprint') }}</h1>
            <div
                class="inline-block mb-24 text-lg font-bold underline cursor-pointer text-text"
                @click="scrollToEnglishVersion()"
            >
                To the English version
            </div>

            <p class="adsimple-121283491">
                Informationspflicht laut §5 E-Commerce Gesetz, §14
                Unternehmensgesetzbuch, §63 Gewerbeordnung und
                Offenlegungspflicht laut §25 Mediengesetz.
            </p>
            <p class="adsimple-121283491"></p>
            <p>Raphael Bernhart</p>
            <p class="adsimple-121283491">
                Achenweg 30, Top 4,
                <br />
                6364 Brixen im Thale,
                <br />
                Österreich
            </p>
            <p>USt-Idnr: ATU76240989</p>
            <p class="adsimple-121283491">
                <strong>Tel.:</strong>
                +43 664 860 65 67
                <br />
                <strong>E-Mail:</strong>
                <a href="mailto:mail@raphaelbernhart.at">
                    mail@raphaelbernhart.at
                </a>
            </p>
            <p style="margin-top: 15px">
                Quelle: Erstellt mit dem Impressum Generator von
                <a
                    href="https://www.adsimple.at/linkbuilding-backlinkaufbau/"
                    title="AdSimple® Linkbuiling"
                    rel="follow noopener noreferrer"
                    target="_blank"
                >
                    AdSimple® Linkbuilding
                </a>
                in Kooperation mit
                <a
                    href="https://www.bauguide.at/"
                    target="_blank"
                    rel="follow noopener noreferrer"
                >
                    bauguide.at
                </a>
            </p>
            <h2 id="eu-streitschlichtung" class="adsimple-121283491">
                EU-Streitschlichtung
            </h2>
            <p>
                Gemäß Verordnung über Online-Streitbeilegung in
                Verbraucherangelegenheiten (ODR-Verordnung) möchten wir Sie über
                die Online-Streitbeilegungsplattform (OS-Plattform) informieren.
                <br />
                Verbraucher haben die Möglichkeit, Beschwerden an die Online
                Streitbeilegungsplattform der Europäischen Kommission unter
                <a
                    class="adsimple-121283491"
                    href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=DE"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    http://ec.europa.eu/odr?tid=121283491
                </a>
                zu richten. Die dafür notwendigen Kontaktdaten finden Sie
                oberhalb in unserem Impressum.
            </p>
            <p>
                Wir möchten Sie jedoch darauf hinweisen, dass wir nicht bereit
                oder verpflichtet sind, an Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
            </p>
            <h2
                id="haftung-fuer-inhalte-dieser-webseite"
                class="adsimple-121283491"
            >
                Haftung für Inhalte dieser Webseite
            </h2>
            <p>
                Wir entwickeln die Inhalte dieser Webseite ständig weiter und
                bemühen uns korrekte und aktuelle Informationen bereitzustellen.
                Leider können wir keine Haftung für die Korrektheit aller
                Inhalte auf dieser Webseite übernehmen, speziell für jene die
                seitens Dritter bereitgestellt wurden.
            </p>
            <p>
                Sollten Ihnen problematische oder rechtswidrige Inhalte
                auffallen, bitten wir Sie uns umgehend zu kontaktieren, Sie
                finden die Kontaktdaten im Impressum.
            </p>
            <h2 id="haftung-links-webseite" class="adsimple-121283491">
                Haftung für Links auf dieser Webseite
            </h2>
            <p>
                Unsere Webseite enthält Links zu anderen Webseiten für deren
                Inhalt wir nicht verantwortlich sind. Haftung für verlinkte
                Websites besteht laut
                <a
                    class="adsimple-121283491"
                    href="https://www.ris.bka.gv.at/Dokument.wxe?Abfrage=Bundesnormen&Dokumentnummer=NOR40025813&tid=121283491"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    § 17 ECG
                </a>
                für uns nicht, da wir keine Kenntnis rechtswidriger Tätigkeiten
                hatten und haben, uns solche Rechtswidrigkeiten auch bisher
                nicht aufgefallen sind und wir Links sofort entfernen würden,
                wenn uns Rechtswidrigkeiten bekannt werden.
            </p>
            <p>
                Wenn Ihnen rechtswidrige Links auf unserer Website auffallen,
                bitten wir Sie uns zu kontaktieren, Sie finden die Kontaktdaten
                im Impressum.
            </p>
            <h2 id="urheberrechtshinweis" class="adsimple-121283491">
                Urheberrechtshinweis
            </h2>
            <p>
                Alle Inhalte dieser Webseite (Bilder, Fotos, Texte, Videos)
                unterliegen dem Urheberrecht. Falls notwendig, werden wir die
                unerlaubte Nutzung von Teilen der Inhalte unserer Seite
                rechtlich verfolgen.
            </p>
            <p>
                Sollten Sie auf dieser Webseite Inhalte finden, die das
                Urheberrecht verletzen, bitten wir Sie uns zu kontaktieren.
            </p>
            <h2 id="bildernachweis" class="adsimple-121283491">
                Bildernachweis
            </h2>
            <p>
                Die Bilder, Fotos und Grafiken auf dieser Webseite sind
                urheberrechtlich geschützt.
            </p>
            <p>
                Die Bilderrechte liegen bei den folgenden Fotografen und
                Unternehmen:
            </p>
            <ul class="adsimple-121283491">
                <li class="adsimple-121283491">Fotograf Mustermann</li>
            </ul>
            <h1 class="adsimple-121283491" id="datenschutzerklärung">
                Datenschutzerklärung
            </h1>
            <h2>Inhaltsverzeichnis</h2>
            <ul>
                <li>
                    <a href="#datenschutz">Datenschutz</a>
                </li>
                <li>
                    <a href="#automatische-datenspeicherung">
                        Automatische Datenspeicherung
                    </a>
                </li>
                <li>
                    <a href="#cookies">Cookies</a>
                </li>
                <li>
                    <a href="#rechte-dsgvo">
                        Rechte laut Datenschutzgrundverordnung
                    </a>
                </li>
                <li>
                    <a href="#auswertung-des-besucherverhaltens">
                        Auswertung des Besucherverhaltens
                    </a>
                </li>
                <li>
                    <a href="#tls-verschluesselung-https">
                        TLS-Verschlüsselung mit https
                    </a>
                </li>
                <li>
                    <a href="#google-fonts-datenschutzerklaerung">
                        Google Fonts Datenschutzerklärung
                    </a>
                </li>
                <li>
                    <a href="#google-fonts-lokal-datenschutzerklaerung">
                        Google Fonts Lokal Datenschutzerklärung
                    </a>
                </li>
                <li>
                    <a href="#google-analytics-datenschutzerklaerung">
                        Google Analytics Datenschutzerklärung
                    </a>
                </li>
                <li>
                    <a href="#google-analytics-ip-anonymisierung">
                        Google Analytics IP-Anonymisierung
                    </a>
                </li>
                <li>
                    <a
                        href="#google-analytics-berichte-zu-demografischen-merkmalen-und-interessen"
                    >
                        Google Analytics Berichte zu demografischen Merkmalen
                        und Interessen
                    </a>
                </li>
                <li>
                    <a href="#google-analytics-deaktivierungslink">
                        Google Analytics Deaktivierungslink
                    </a>
                </li>
                <li>
                    <a href="#google-analytics-zusatz-zur-datenverarbeitung">
                        Google Analytics Zusatz zur Datenverarbeitung
                    </a>
                </li>
                <li>
                    <a
                        href="#google-analytics-google-signale-datenschutzerklaerung"
                    >
                        Google Analytics Google-Signale Datenschutzerklärung
                    </a>
                </li>
                <li>
                    <a href="#google-tag-manager-datenschutzerklaerung">
                        Google Tag Manager Datenschutzerklärung
                    </a>
                </li>
                <li>
                    <a
                        href="#eingebettete-social-media-elemente-datenschutzerklaerung"
                    >
                        Eingebettete Social Media Elemente Datenschutzerklärung
                    </a>
                </li>
            </ul>
            <h2 id="datenschutz" class="adsimple-121283491">Datenschutz</h2>
            <p>
                Wir haben diese Datenschutzerklärung (Fassung
                01.01.1970-121283491) verfasst, um Ihnen gemäß der Vorgaben der
                <a
                    class="adsimple-121283491"
                    href="https://eur-lex.europa.eu/legal-content/DE/ALL/?uri=celex%3A32016R0679&tid=121283491"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Datenschutz-Grundverordnung (EU) 2016/679
                </a>
                zu erklären, welche Informationen wir sammeln, wie wir Daten
                verwenden und welche Entscheidungsmöglichkeiten Sie als Besucher
                dieser Webseite haben.
            </p>
            <p>
                Leider liegt es in der Natur der Sache, dass diese Erklärungen
                sehr technisch klingen, wir haben uns bei der Erstellung jedoch
                bemüht die wichtigsten Dinge so einfach und klar wie möglich zu
                beschreiben.
            </p>
            <h2 id="automatische-datenspeicherung" class="adsimple-121283491">
                Automatische Datenspeicherung
            </h2>
            <p>
                Wenn Sie heutzutage Webseiten besuchen, werden gewisse
                Informationen automatisch erstellt und gespeichert, so auch auf
                dieser Webseite.
            </p>
            <p>
                Wenn Sie unsere Webseite so wie jetzt gerade besuchen, speichert
                unser Webserver (Computer auf dem diese Webseite gespeichert
                ist) automatisch Daten wie
            </p>
            <ul class="adsimple-121283491">
                <li class="adsimple-121283491">
                    die Adresse (URL) der aufgerufenen Webseite
                </li>
                <li class="adsimple-121283491">Browser und Browserversion</li>
                <li class="adsimple-121283491">
                    das verwendete Betriebssystem
                </li>
                <li class="adsimple-121283491">
                    die Adresse (URL) der zuvor besuchten Seite (Referrer URL)
                </li>
                <li class="adsimple-121283491">
                    den Hostname und die IP-Adresse des Geräts von welchem aus
                    zugegriffen wird
                </li>
                <li class="adsimple-121283491">Datum und Uhrzeit</li>
            </ul>
            <p>in Dateien (Webserver-Logfiles).</p>
            <p>
                In der Regel werden Webserver-Logfiles zwei Wochen gespeichert
                und danach automatisch gelöscht. Wir geben diese Daten nicht
                weiter, können jedoch nicht ausschließen, dass diese Daten beim
                Vorliegen von rechtswidrigem Verhalten eingesehen werden.
            </p>
            <h2 id="cookies" class="adsimple-121283491">Cookies</h2>
            <p>
                Unsere Webseite verwendet HTTP-Cookies, um nutzerspezifische
                Daten zu speichern.
                <br />
                Im Folgenden erklären wir, was Cookies sind und warum Sie
                genutzt werden, damit Sie die folgende Datenschutzerklärung
                besser verstehen.
            </p>
            <h3 class="adsimple-121283491">Was genau sind Cookies?</h3>
            <p>
                Immer wenn Sie durch das Internet surfen, verwenden Sie einen
                Browser. Bekannte Browser sind beispielsweise Chrome, Safari,
                Firefox, Internet Explorer und Microsoft Edge. Die meisten
                Webseiten speichern kleine Text-Dateien in Ihrem Browser. Diese
                Dateien nennt man Cookies.
            </p>
            <p>
                Eines ist nicht von der Hand zu weisen: Cookies sind echt
                nützliche Helferlein. Fast alle Webseiten verwenden Cookies.
                Genauer gesprochen sind es HTTP-Cookies, da es auch noch andere
                Cookies für andere Anwendungsbereiche gibt. HTTP-Cookies sind
                kleine Dateien, die von unserer Webseite auf Ihrem Computer
                gespeichert werden. Diese Cookie-Dateien werden automatisch im
                Cookie-Ordner, quasi dem “Hirn” Ihres Browsers, untergebracht.
                Ein Cookie besteht aus einem Namen und einem Wert. Bei der
                Definition eines Cookies müssen zusätzlich ein oder mehrere
                Attribute angegeben werden.
            </p>
            <p>
                Cookies speichern gewisse Nutzerdaten von Ihnen, wie
                beispielsweise Sprache oder persönliche Seiteneinstellungen.
                Wenn Sie unsere Seite wieder aufrufen, übermittelt Ihr Browser
                die „userbezogenen“ Informationen an unsere Seite zurück. Dank
                der Cookies weiß unsere Webseite, wer Sie sind und bietet Ihnen
                die Einstellung, die Sie gewohnt sind. In einigen Browsern hat
                jedes Cookie eine eigene Datei, in anderen wie beispielsweise
                Firefox sind alle Cookies in einer einzigen Datei gespeichert.
            </p>
            <p>
                Es gibt sowohl Erstanbieter Cookies als auch
                Drittanbieter-Cookies. Erstanbieter-Cookies werden direkt von
                unserer Seite erstellt, Drittanbieter-Cookies werden von
                Partner-Webseiten (z.B. Google Analytics) erstellt. Jedes Cookie
                ist individuell zu bewerten, da jedes Cookie andere Daten
                speichert. Auch die Ablaufzeit eines Cookies variiert von ein
                paar Minuten bis hin zu ein paar Jahren. Cookies sind keine
                Software-Programme und enthalten keine Viren, Trojaner oder
                andere „Schädlinge“. Cookies können auch nicht auf Informationen
                Ihres PCs zugreifen.
            </p>
            <p>So können zum Beispiel Cookie-Daten aussehen:</p>
            <p>
                <strong class="adsimple-121283491">Name:</strong>
                _ga
                <br />
                <strong class="adsimple-121283491">Wert:</strong>
                GA1.2.1326744211.152121283491-9
                <br />
                <strong class="adsimple-121283491">Verwendungszweck:</strong>
                Unterscheidung der Webseitenbesucher
                <br />
                <strong class="adsimple-121283491">Ablaufdatum:</strong>
                nach 2 Jahren
            </p>
            <p>Diese Mindestgrößen sollte ein Browser unterstützen können:</p>
            <ul class="adsimple-121283491">
                <li class="adsimple-121283491">
                    Mindestens 4096 Bytes pro Cookie
                </li>
                <li class="adsimple-121283491">
                    Mindestens 50 Cookies pro Domain
                </li>
                <li class="adsimple-121283491">
                    Mindestens 3000 Cookies insgesamt
                </li>
            </ul>
            <h3 class="adsimple-121283491">
                Welche Arten von Cookies gibt es?
            </h3>
            <p>
                Die Frage welche Cookies wir im Speziellen verwenden, hängt von
                den verwendeten Diensten ab und wird in den folgenden
                Abschnitten der Datenschutzerklärung geklärt. An dieser Stelle
                möchten wir kurz auf die verschiedenen Arten von HTTP-Cookies
                eingehen.
            </p>
            <p>Man kann 4 Arten von Cookies unterscheiden:</p>
            <p>
                <strong class="adsimple-121283491">
                    Unerlässliche Cookies
                    <br />
                </strong>
                Diese Cookies sind nötig, um grundlegende Funktionen der
                Webseite sicherzustellen. Zum Beispiel braucht es diese Cookies,
                wenn ein User ein Produkt in den Warenkorb legt, dann auf
                anderen Seiten weitersurft und später erst zur Kasse geht. Durch
                diese Cookies wird der Warenkorb nicht gelöscht, selbst wenn der
                User sein Browserfenster schließt.
            </p>
            <p>
                <strong class="adsimple-121283491">
                    Zweckmäßige Cookies
                    <br />
                </strong>
                Diese Cookies sammeln Infos über das Userverhalten und ob der
                User etwaige Fehlermeldungen bekommt. Zudem werden mithilfe
                dieser Cookies auch die Ladezeit und das Verhalten der Webseite
                bei verschiedenen Browsern gemessen.
            </p>
            <p>
                <strong class="adsimple-121283491">
                    Zielorientierte Cookies
                    <br />
                </strong>
                Diese Cookies sorgen für eine bessere Nutzerfreundlichkeit.
                Beispielsweise werden eingegebene Standorte, Schriftgrößen oder
                Formulardaten gespeichert.
            </p>
            <p>
                <strong class="adsimple-121283491">
                    Werbe-Cookies
                    <br />
                </strong>
                Diese Cookies werden auch Targeting-Cookies genannt. Sie dienen
                dazu dem User individuell angepasste Werbung zu liefern. Das
                kann sehr praktisch, aber auch sehr nervig sein.
            </p>
            <p>
                Üblicherweise werden Sie beim erstmaligen Besuch einer Webseite
                gefragt, welche dieser Cookiearten Sie zulassen möchten. Und
                natürlich wird diese Entscheidung auch in einem Cookie
                gespeichert.
            </p>
            <h3 class="adsimple-121283491">Wie kann ich Cookies löschen?</h3>
            <p>
                Wie und ob Sie Cookies verwenden wollen, entscheiden Sie selbst.
                Unabhängig von welchem Service oder welcher Webseite die Cookies
                stammen, haben Sie immer die Möglichkeit Cookies zu löschen, zu
                deaktivieren oder nur teilweise zuzulassen. Zum Beispiel können
                Sie Cookies von Drittanbietern blockieren, aber alle anderen
                Cookies zulassen.
            </p>
            <p>
                Wenn Sie feststellen möchten, welche Cookies in Ihrem Browser
                gespeichert wurden, wenn Sie Cookie-Einstellungen ändern oder
                löschen wollen, können Sie dies in Ihren Browser-Einstellungen
                finden:
            </p>
            <p>
                <a
                    class="adsimple-121283491"
                    href="https://support.google.com/chrome/answer/95647?tid=121283491"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Chrome: Cookies in Chrome löschen, aktivieren und verwalten
                </a>
            </p>
            <p>
                <a
                    class="adsimple-121283491"
                    href="https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=121283491"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Safari: Verwalten von Cookies und Websitedaten mit Safari
                </a>
            </p>
            <p>
                <a
                    class="adsimple-121283491"
                    href="https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=121283491"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Firefox: Cookies löschen, um Daten zu entfernen, die
                    Websites auf Ihrem Computer abgelegt haben
                </a>
            </p>
            <p>
                <a
                    class="adsimple-121283491"
                    href="https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=121283491"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Internet Explorer: Löschen und Verwalten von Cookies
                </a>
            </p>
            <p>
                <a
                    class="adsimple-121283491"
                    href="https://support.microsoft.com/de-at/help/4027947/windows-delete-cookies?tid=121283491"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Microsoft Edge: Löschen und Verwalten von Cookies
                </a>
            </p>
            <p>
                Falls Sie grundsätzlich keine Cookies haben wollen, können Sie
                Ihren Browser so einrichten, dass er Sie immer informiert, wenn
                ein Cookie gesetzt werden soll. So können Sie bei jedem
                einzelnen Cookie entscheiden, ob Sie das Cookie erlauben oder
                nicht. Die Vorgangsweise ist je nach Browser verschieden. Am
                besten Sie suchen die Anleitung in Google mit dem Suchbegriff
                “Cookies löschen Chrome” oder “Cookies deaktivieren Chrome” im
                Falle eines Chrome Browsers.
            </p>
            <h3 class="adsimple-121283491">
                Wie sieht es mit meinem Datenschutz aus?
            </h3>
            <p>
                Seit 2009 gibt es die sogenannten „Cookie-Richtlinien“. Darin
                ist festgehalten, dass das Speichern von Cookies eine
                Einwilligung des von Ihnen verlangt. Innerhalb der EU-Länder
                gibt es allerdings noch sehr unterschiedliche Reaktionen auf
                diese Richtlinien. In Österreich erfolgte aber die Umsetzung
                dieser Richtlinie in § 96 Abs. 3 des Telekommunikationsgesetzes
                (TKG).
            </p>
            <p>
                Wenn Sie mehr über Cookies wissen möchten und vor technischen
                Dokumentationen nicht zurückscheuen, empfehlen wir
                <a
                    class="adsimple-121283491"
                    href="https://tools.ietf.org/html/rfc6265"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                >
                    https://tools.ietf.org/html/rfc6265
                </a>
                , dem Request for Comments der Internet Engineering Task Force
                (IETF) namens “HTTP State Management Mechanism”.
            </p>
            <h2 id="rechte-dsgvo" class="adsimple-121283491">
                Rechte laut Datenschutzgrundverordnung
            </h2>
            <p>
                Ihnen stehen laut den Bestimmungen der DSGVO und des
                österreichischen
                <a
                    class="adsimple-121283491"
                    href="https://www.ris.bka.gv.at/GeltendeFassung.wxe?Abfrage=Bundesnormen&Gesetzesnummer=10001597&tid=121283491"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Datenschutzgesetzes (DSG)
                </a>
                grundsätzlich die folgende Rechte zu:
            </p>
            <ul class="adsimple-121283491">
                <li class="adsimple-121283491">
                    Recht auf Berichtigung (Artikel 16 DSGVO)
                </li>
                <li class="adsimple-121283491">
                    Recht auf Löschung („Recht auf Vergessenwerden“) (Artikel 17
                    DSGVO)
                </li>
                <li class="adsimple-121283491">
                    Recht auf Einschränkung der Verarbeitung (Artikel 18 DSGVO)
                </li>
                <li class="adsimple-121283491">
                    Recht auf Benachrichtigung – Mitteilungspflicht im
                    Zusammenhang mit der Berichtigung oder Löschung
                    personenbezogener Daten oder der Einschränkung der
                    Verarbeitung (Artikel 19 DSGVO)
                </li>
                <li class="adsimple-121283491">
                    Recht auf Datenübertragbarkeit (Artikel 20 DSGVO)
                </li>
                <li class="adsimple-121283491">
                    Widerspruchsrecht (Artikel 21 DSGVO)
                </li>
                <li class="adsimple-121283491">
                    Recht, nicht einer ausschließlich auf einer automatisierten
                    Verarbeitung — einschließlich Profiling — beruhenden
                    Entscheidung unterworfen zu werden (Artikel 22 DSGVO)
                </li>
            </ul>
            <p>
                Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das
                Datenschutzrecht verstößt oder Ihre datenschutzrechtlichen
                Ansprüche sonst in einer Weise verletzt worden sind, können Sie
                sich bei der Aufsichtsbehörde beschweren, welche in Österreich
                die Datenschutzbehörde ist, deren Webseite Sie unter
                <a
                    class="adsimple-121283491"
                    href="https://www.dsb.gv.at/?tid=121283491"
                >
                    https://www.dsb.gv.at/
                </a>
                finden.
            </p>
            <h2
                id="auswertung-des-besucherverhaltens"
                class="adsimple-121283491"
            >
                Auswertung des Besucherverhaltens
            </h2>
            <p>
                In der folgenden Datenschutzerklärung informieren wir Sie
                darüber, ob und wie wir Daten Ihres Besuchs dieser Website
                auswerten. Die Auswertung der gesammelten Daten erfolgt in der
                Regel anonym und wir können von Ihrem Verhalten auf dieser
                Website nicht auf Ihre Person schließen.
            </p>
            <p>
                Mehr über Möglichkeiten dieser Auswertung der Besuchsdaten zu
                widersprechen erfahren Sie in der folgenden
                Datenschutzerklärung.
            </p>
            <h2 id="tls-verschluesselung-https" class="adsimple-121283491">
                TLS-Verschlüsselung mit https
            </h2>
            <p>
                Wir verwenden https um Daten abhörsicher im Internet zu
                übertragen (Datenschutz durch Technikgestaltung
                <a
                    class="adsimple-121283491"
                    href="https://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE&tid=121283491"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Artikel 25 Absatz 1 DSGVO
                </a>
                ). Durch den Einsatz von TLS (Transport Layer Security), einem
                Verschlüsselungsprotokoll zur sicheren Datenübertragung im
                Internet können wir den Schutz vertraulicher Daten
                sicherstellen. Sie erkennen die Benutzung dieser Absicherung der
                Datenübertragung am kleinen Schlosssymbol links oben im Browser
                und der Verwendung des Schemas https (anstatt http) als Teil
                unserer Internetadresse.
            </p>
            <h2
                id="google-fonts-datenschutzerklaerung"
                class="adsimple-121283491"
            >
                Google Fonts Datenschutzerklärung
            </h2>
            <p>
                Auf unserer Website verwenden wir Google Fonts. Das sind die
                “Google-Schriften” der Firma Google Inc. Für den europäischen
                Raum ist das Unternehmen Google Ireland Limited (Gordon House,
                Barrow Street Dublin 4, Irland) für alle Google-Dienste
                verantwortlich.
            </p>
            <p>
                Für die Verwendung von Google-Schriftarten müssen Sie sich nicht
                anmelden bzw. ein Passwort hinterlegen. Weiters werden auch
                keine Cookies in Ihrem Browser gespeichert. Die Dateien (CSS,
                Schriftarten/Fonts) werden über die Google-Domains
                fonts.googleapis.com und fonts.gstatic.com angefordert. Laut
                Google sind die Anfragen nach CSS und Schriften vollkommen
                getrennt von allen anderen Google-Diensten. Wenn Sie ein
                Google-Konto haben, brauchen Sie keine Sorge haben, dass Ihre
                Google-Kontodaten, während der Verwendung von Google Fonts, an
                Google übermittelt werden. Google erfasst die Nutzung von CSS
                (Cascading Style Sheets) und der verwendeten Schriftarten und
                speichert diese Daten sicher. Wie die Datenspeicherung genau
                aussieht, werden wir uns noch im Detail ansehen.
            </p>
            <h3 class="adsimple-121283491">Was sind Google Fonts?</h3>
            <p>
                Google Fonts (früher Google Web Fonts) ist ein Verzeichnis mit
                über 800 Schriftarten, die
                <a
                    class="adsimple-121283491"
                    href="https://de.wikipedia.org/wiki/Google_LLC?tid=121283491"
                >
                    Google
                </a>
                Ihren Nutzern kostenlos zu Verfügung stellen.
            </p>
            <p>
                Viele dieser Schriftarten sind unter der SIL Open Font License
                veröffentlicht, während andere unter der Apache-Lizenz
                veröffentlicht wurden. Beides sind freie Software-Lizenzen.
            </p>
            <h3 class="adsimple-121283491">
                Warum verwenden wir Google Fonts auf unserer Webseite?
            </h3>
            <p>
                Mit Google Fonts können wir auf der eigenen Webseite Schriften
                nutzen, und müssen sie nicht auf unserem eigenen Server
                hochladen. Google Fonts ist ein wichtiger Baustein, um die
                Qualität unserer Webseite hoch zu halten. Alle Google-Schriften
                sind automatisch für das Web optimiert und dies spart
                Datenvolumen und ist speziell für die Verwendung bei mobilen
                Endgeräten ein großer Vorteil. Wenn Sie unsere Seite besuchen,
                sorgt die niedrige Dateigröße für eine schnelle Ladezeit. Des
                Weiteren sind Google Fonts sichere Web Fonts. Unterschiedliche
                Bildsynthese-Systeme (Rendering) in verschiedenen Browsern,
                Betriebssystemen und mobilen Endgeräten können zu Fehlern
                führen. Solche Fehler können teilweise Texte bzw. ganze
                Webseiten optisch verzerren. Dank des schnellen Content Delivery
                Network (CDN) gibt es mit Google Fonts keine
                plattformübergreifenden Probleme. Google Fonts unterstützt alle
                gängigen Browser (Google Chrome, Mozilla Firefox, Apple Safari,
                Opera) und funktioniert zuverlässig auf den meisten modernen
                mobilen Betriebssystemen, einschließlich Android 2.2+ und iOS
                4.2+ (iPhone, iPad, iPod). Wir verwenden die Google Fonts also,
                damit wir unser gesamtes Online-Service so schön und einheitlich
                wie möglich darstellen können.
            </p>
            <h3 class="adsimple-121283491">
                Welche Daten werden von Google gespeichert?
            </h3>
            <p>
                Wenn Sie unsere Webseite besuchen, werden die Schriften über
                einen Google-Server nachgeladen. Durch diesen externen Aufruf
                werden Daten an die Google-Server übermittelt. So erkennt Google
                auch, dass Sie bzw. Ihre IP-Adresse unsere Webseite besucht. Die
                Google Fonts API wurde entwickelt, um Verwendung, Speicherung
                und Erfassung von Endnutzerdaten auf das zu reduzieren, was für
                eine ordentliche Bereitstellung von Schriften nötig ist. API
                steht übrigens für „Application Programming Interface“ und dient
                unter anderem als Datenübermittler im Softwarebereich.
            </p>
            <p>
                Google Fonts speichert CSS- und Schrift-Anfragen sicher bei
                Google und ist somit geschützt. Durch die gesammelten
                Nutzungszahlen kann Google feststellen, wie gut die einzelnen
                Schriften ankommen. Die Ergebnisse veröffentlicht Google auf
                internen Analyseseiten, wie beispielsweise Google Analytics.
                Zudem verwendet Google auch Daten des eigenen Web-Crawlers, um
                festzustellen, welche Webseiten Google-Schriften verwenden.
                Diese Daten werden in der BigQuery-Datenbank von Google Fonts
                veröffentlicht. Unternehmer und Entwickler nützen das
                Google-Webservice BigQuery, um große Datenmengen untersuchen und
                bewegen zu können.
            </p>
            <p>
                Zu bedenken gilt allerdings noch, dass durch jede Google Font
                Anfrage auch Informationen wie Spracheinstellungen, IP-Adresse,
                Version des Browsers, Bildschirmauflösung des Browsers und Name
                des Browsers automatisch an die Google-Server übertragen werden.
                Ob diese Daten auch gespeichert werden, ist nicht klar
                feststellbar bzw. wird von Google nicht eindeutig kommuniziert.
            </p>
            <h3 class="adsimple-121283491">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Anfragen für CSS-Assets speichert Google einen Tag lang auf
                seinen Servern, die hauptsächlich außerhalb der EU angesiedelt
                sind. Das ermöglicht uns, mithilfe eines Google-Stylesheets die
                Schriftarten zu nutzen. Ein Stylesheet ist eine Formatvorlage,
                über die man einfach und schnell z.B. das Design bzw. die
                Schriftart einer Webseite ändern kann.
            </p>
            <p>
                Die Font-Dateien werden bei Google ein Jahr gespeichert. Google
                verfolgt damit das Ziel, die Ladezeit von Webseiten
                grundsätzlich zu verbessern. Wenn Millionen von Webseiten auf
                die gleichen Schriften verweisen, werden sie nach dem ersten
                Besuch zwischengespeichert und erscheinen sofort auf allen
                anderen später besuchten Webseiten wieder. Manchmal aktualisiert
                Google Schriftdateien, um die Dateigröße zu reduzieren, die
                Abdeckung von Sprache zu erhöhen und das Design zu verbessern.
            </p>
            <h3 class="adsimple-121283491">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung
                verhindern?
            </h3>
            <p>
                Jene Daten, die Google für einen Tag bzw. ein Jahr speichert
                können nicht einfach gelöscht werden. Die Daten werden beim
                Seitenaufruf automatisch an Google übermittelt. Um diese Daten
                vorzeitig löschen zu können, müssen Sie den Google-Support auf
                <a
                    class="adsimple-121283491"
                    href="https://support.google.com/?hl=de&tid=121283491"
                >
                    https://support.google.com/?hl=de&tid=121283491
                </a>
                kontaktieren. Datenspeicherung verhindern Sie in diesem Fall
                nur, wenn Sie unsere Seite nicht besuchen.
            </p>
            <p>
                Anders als andere Web-Schriften erlaubt uns Google
                uneingeschränkten Zugriff auf alle Schriftarten. Wir können also
                unlimitiert auf ein Meer an Schriftarten zugreifen und so das
                Optimum für unsere Webseite rausholen. Mehr zu Google Fonts und
                weiteren Fragen finden Sie auf
                <a
                    class="adsimple-121283491"
                    href="https://developers.google.com/fonts/faq?tid=121283491"
                >
                    https://developers.google.com/fonts/faq?tid=121283491
                </a>
                . Dort geht zwar Google auf datenschutzrelevante Angelegenheiten
                ein, doch wirklich detaillierte Informationen über
                Datenspeicherung sind nicht enthalten. Es ist relativ schwierig,
                von Google wirklich präzise Informationen über gespeicherten
                Daten zu bekommen.
            </p>
            <p>
                Welche Daten grundsätzlich von Google erfasst werden und wofür
                diese Daten verwendet werden, können Sie auch auf
                <a
                    class="adsimple-121283491"
                    href="https://policies.google.com/privacy?hl=de&tid=121283491"
                >
                    https://www.google.com/intl/de/policies/privacy/
                </a>
                nachlesen.
            </p>
            <h2
                id="google-fonts-lokal-datenschutzerklaerung"
                class="adsimple-121283491"
            >
                Google Fonts Lokal Datenschutzerklärung
            </h2>
            <p>
                Auf unserer Website nutzen wir Google Fonts der Firma Google
                Inc. Für den europäischen Raum ist das Unternehmen Google
                Ireland Limited (Gordon House, Barrow Street Dublin 4, Irland)
                verantwortlich. Wir haben die Google-Schriftarten lokal, d.h.
                auf unserem Webserver – nicht auf den Servern von Google –
                eingebunden. Dadurch gibt es keine Verbindung zu Google-Servern
                und somit auch keine Datenübertragung oder Speicherung.
            </p>
            <h3 class="adsimple-121283491">Was sind Google Fonts?</h3>
            <p>
                Früher nannte man Google Fonts auch Google Web Fonts. Dabei
                handelt es sich um ein interaktives Verzeichnis mit über 800
                Schriftarten, die
                <a
                    class="adsimple-121283491"
                    href="https://de.wikipedia.org/wiki/Google_LLC?tid=121283491"
                >
                    Google
                </a>
                kostenlos bereitstellt. Mit Google Fonts könnte man Schriften
                nutzen, ohne sie auf den eigenen Server hochzuladen. Doch um
                diesbezüglich jede Informationsübertragung zu Google-Servern zu
                unterbinden, haben wir die Schriftarten auf unseren Server
                heruntergeladen. Auf diese Weise handeln wir datenschutzkonform
                und senden keine Daten an Google Fonts weiter.
            </p>
            <p>
                Anders als andere Web-Schriften erlaubt uns Google
                uneingeschränkten Zugriff auf alle Schriftarten. Wir können also
                unlimitiert auf ein Meer an Schriftarten zugreifen und so das
                Optimum für unsere Webseite rausholen. Mehr zu Google Fonts und
                weiteren Fragen finden Sie auf
                <a
                    class="adsimple-121283491"
                    href="https://developers.google.com/fonts/faq?tid=121283491"
                >
                    https://developers.google.com/fonts/faq?tid=121283491
                </a>
                .
            </p>
            <h2
                id="google-analytics-datenschutzerklaerung"
                class="adsimple-121283491"
            >
                Google Analytics Datenschutzerklärung
            </h2>
            <p>
                Wir verwenden auf unserer Website das Analyse-Tracking Tool
                Google Analytics (GA) des amerikanischen Unternehmens Google
                Inc. Für den europäischen Raum ist das Unternehmen Google
                Ireland Limited (Gordon House, Barrow Street Dublin 4, Irland)
                für alle Google-Dienste verantwortlich. Google Analytics sammelt
                Daten über Ihre Handlungen auf unserer Website. Wenn Sie
                beispielsweise einen Link anklicken, wird diese Aktion in einem
                Cookie gespeichert und an Google Analytics versandt. Mithilfe
                der Berichte, die wir von Google Analytics erhalten, können wir
                unsere Website und unser Service besser an Ihre Wünsche
                anpassen. Im Folgenden gehen wir näher auf das Tracking Tool ein
                und informieren Sie vor allem darüber, welche Daten gespeichert
                werden und wie Sie das verhindern können.
            </p>
            <h3 class="adsimple-121283491">Was ist Google Analytics?</h3>
            <p>
                Google Analytics ist ein Trackingtool, das der
                Datenverkehrsanalyse unserer Website dient. Damit Google
                Analytics funktioniert, wird ein Tracking-Code in den Code
                unserer Website eingebaut. Wenn Sie unsere Website besuchen,
                zeichnet dieser Code verschiedene Handlungen auf, die Sie auf
                unserer Website ausführen. Sobald Sie unsere Website verlassen,
                werden diese Daten an die Google-Analytics-Server gesendet und
                dort gespeichert.
            </p>
            <p>
                Google verarbeitet die Daten und wir bekommen Berichte über Ihr
                Userverhalten. Dabei kann es sich unter anderem um folgende
                Berichte handeln:
            </p>
            <ul class="adsimple-121283491">
                <li class="adsimple-121283491">
                    Zielgruppenberichte: Über Zielgruppenberichte lernen wir
                    unsere User besser kennen und wissen genauer, wer sich für
                    unser Service interessiert.
                </li>
                <li class="adsimple-121283491">
                    Anzeigeberichte: Durch Anzeigeberichte können wir unsere
                    Onlinewerbung leichter analysieren und verbessern.
                </li>
                <li class="adsimple-121283491">
                    Akquisitionsberichte: Akquisitionsberichte geben uns
                    hilfreiche Informationen darüber, wie wir mehr Menschen für
                    unser Service begeistern können.
                </li>
                <li class="adsimple-121283491">
                    Verhaltensberichte: Hier erfahren wir, wie Sie mit unserer
                    Website interagieren. Wir können nachvollziehen welchen Weg
                    Sie auf unserer Seite zurücklegen und welche Links Sie
                    anklicken.
                </li>
                <li class="adsimple-121283491">
                    Conversionsberichte: Conversion nennt man einen Vorgang, bei
                    dem Sie aufgrund einer Marketing-Botschaft eine gewünschte
                    Handlung ausführen. Zum Beispiel, wenn Sie von einem reinen
                    Websitebesucher zu einem Käufer oder Newsletter-Abonnent
                    werden. Mithilfe dieser Berichte erfahren wir mehr darüber,
                    wie unsere Marketing-Maßnahmen bei Ihnen ankommen. So wollen
                    wir unsere Conversionrate steigern.
                </li>
                <li class="adsimple-121283491">
                    Echtzeitberichte: Hier erfahren wir immer sofort, was gerade
                    auf unserer Website passiert. Zum Beispiel sehen wir wie
                    viele User gerade diesen Text lesen.
                </li>
            </ul>
            <h3 class="adsimple-121283491">
                Warum verwenden wir Google Analytics auf unserer Webseite?
            </h3>
            <p>
                Unser Ziel mit dieser Website ist klar: Wir wollen Ihnen das
                bestmögliche Service bieten. Die Statistiken und Daten von
                Google Analytics helfen uns dieses Ziel zu erreichen.
            </p>
            <p>
                Die statistisch ausgewerteten Daten zeigen uns ein klares Bild
                von den Stärken und Schwächen unserer Website. Einerseits können
                wir unsere Seite so optimieren, dass sie von interessierten
                Menschen auf Google leichter gefunden wird. Andererseits helfen
                uns die Daten, Sie als Besucher besser zu verstehen. Wir wissen
                somit sehr genau, was wir an unserer Website verbessern müssen,
                um Ihnen das bestmögliche Service zu bieten. Die Daten dienen
                uns auch, unsere Werbe- und Marketing-Maßnahmen individueller
                und kostengünstiger durchzuführen. Schließlich macht es nur
                Sinn, unsere Produkte und Dienstleistungen Menschen zu zeigen,
                die sich dafür interessieren.
            </p>
            <h3 class="adsimple-121283491">
                Welche Daten werden von Google Analytics gespeichert?
            </h3>
            <p>
                Google Analytics erstellt mithilfe eines Tracking-Codes eine
                zufällige, eindeutige ID, die mit Ihrem Browser-Cookie verbunden
                ist. So erkennt Sie Google Analytics als neuen User. Wenn Sie
                das nächste Mal unsere Seite besuchen, werden Sie als
                „wiederkehrender“ User erkannt. Alle gesammelten Daten werden
                gemeinsam mit dieser User-ID gespeichert. So ist es überhaupt
                erst möglich pseudonyme Userprofile auszuwerten.
            </p>
            <p>
                Durch Kennzeichnungen wie Cookies und App-Instanz-IDs werden
                Ihre Interaktionen auf unserer Website gemessen. Interaktionen
                sind alle Arten von Handlungen, die Sie auf unserer Website
                ausführen. Wenn Sie auch andere Google-Systeme (wie z.B. ein
                Google-Konto) nützen, können über Google Analytics generierte
                Daten mit Drittanbieter-Cookies verknüpft werden. Google gibt
                keine Google Analytics-Daten weiter, außer wir als
                Websitebetreiber genehmigen das. Zu Ausnahmen kann es kommen,
                wenn es gesetzlich erforderlich ist.
            </p>
            <p>Folgende Cookies werden von Google Analytics verwendet:</p>
            <p>
                <strong class="adsimple-121283491">Name:</strong>
                _ga
                <br />
                <strong class="adsimple-121283491">Wert:</strong>
                2.1326744211.152121283491-5
                <br />
                <strong class="adsimple-121283491">Verwendungszweck:</strong>
                Standardmäßig verwendet analytics.js das Cookie _ga, um die
                User-ID zu speichern. Grundsätzlich dient es zur Unterscheidung
                der Webseitenbesucher.
                <br />
                <strong class="adsimple-121283491">Ablaufdatum:</strong>
                nach 2 Jahren
            </p>
            <p>
                <strong class="adsimple-121283491">Name:</strong>
                _gid
                <br />
                <strong class="adsimple-121283491">Wert:</strong>
                2.1687193234.152121283491-1
                <br />
                <strong class="adsimple-121283491">Verwendungszweck:</strong>
                Das Cookie dient auch zur Unterscheidung der Webseitenbesucher
                <br />
                <strong class="adsimple-121283491">Ablaufdatum:</strong>
                nach 24 Stunden
            </p>
            <p>
                <strong class="adsimple-121283491">Name:</strong>
                _gat_gtag_UA_
                <br />
                <strong class="adsimple-121283491">Wert:</strong>
                1
                <br />
                <strong class="adsimple-121283491">Verwendungszweck:</strong>
                Wird zum Senken der Anforderungsrate verwendet. Wenn Google
                Analytics über den Google Tag Manager bereitgestellt wird,
                erhält dieser Cookie den Namen _dc_gtm_ .
                <br />
                <strong class="adsimple-121283491">Ablaufdatum:</strong>
                nach 1 Minute
            </p>
            <p>
                <strong class="adsimple-121283491">Name:</strong>
                AMP_TOKEN
                <br />
                <strong class="adsimple-121283491">Wert:</strong>
                keine Angaben
                <br />
                <strong class="adsimple-121283491">Verwendungszweck:</strong>
                Das Cookie hat einen Token, mit dem eine User ID vom
                AMP-Client-ID-Dienst abgerufen werden kann. Andere mögliche
                Werte weisen auf eine Abmeldung, eine Anfrage oder einen Fehler
                hin.
                <br />
                <strong class="adsimple-121283491">Ablaufdatum:</strong>
                nach 30 Sekunden bis zu einem Jahr
            </p>
            <p>
                <strong class="adsimple-121283491">Name:</strong>
                __utma
                <br />
                <strong class="adsimple-121283491">Wert:</strong>
                1564498958.1564498958.1564498958.1
                <br />
                <strong class="adsimple-121283491">Verwendungszweck:</strong>
                Mit diesem Cookie kann man Ihr Verhalten auf der Website
                verfolgen und die Leistung messen. Das Cookie wird jedes Mal
                aktualisiert, wenn Informationen an Google Analytics gesendet
                werden.
                <br />
                <strong class="adsimple-121283491">Ablaufdatum:</strong>
                nach 2 Jahren
            </p>
            <p>
                <strong class="adsimple-121283491">Name:</strong>
                __utmt
                <br />
                <strong class="adsimple-121283491">Wert:</strong>
                1
                <br />
                <strong class="adsimple-121283491">Verwendungszweck:</strong>
                Das Cookie wird wie _gat_gtag_UA_ zum Drosseln der
                Anforderungsrate verwendet.
                <br />
                <strong class="adsimple-121283491">Ablaufdatum:</strong>
                nach 10 Minuten
            </p>
            <p>
                <strong class="adsimple-121283491">Name:</strong>
                __utmb
                <br />
                <strong class="adsimple-121283491">Wert:</strong>
                3.10.1564498958
                <br />
                <strong class="adsimple-121283491">Verwendungszweck:</strong>
                Dieses Cookie wird verwendet, um neue Sitzungen zu bestimmen. Es
                wird jedes Mal aktualisiert, wenn neue Daten bzw. Infos an
                Google Analytics gesendet werden.
                <br />
                <strong class="adsimple-121283491">Ablaufdatum:</strong>
                nach 30 Minuten
            </p>
            <p>
                <strong class="adsimple-121283491">Name:</strong>
                __utmc
                <br />
                <strong class="adsimple-121283491">Wert:</strong>
                167421564
                <br />
                <strong class="adsimple-121283491">Verwendungszweck:</strong>
                Dieses Cookie wird verwendet, um neue Sitzungen für
                wiederkehrende Besucher festzulegen. Dabei handelt es sich um
                ein Session-Cookie und wird nur solange gespeichert, bis Sie den
                Browser wieder schließen.
                <br />
                <strong class="adsimple-121283491">Ablaufdatum:</strong>
                Nach Schließung des Browsers
            </p>
            <p>
                <strong class="adsimple-121283491">Name:</strong>
                __utmz
                <br />
                <strong class="adsimple-121283491">Wert:</strong>
                m|utmccn=(referral)|utmcmd=referral|utmcct=/
                <br />
                <strong class="adsimple-121283491">Verwendungszweck:</strong>
                Das Cookie wird verwendet, um die Quelle des Besucheraufkommens
                auf unserer Website zu identifizieren. Das heißt, das Cookie
                speichert, von wo Sie auf unsere Website gekommen sind. Das kann
                eine andere Seite bzw. eine Werbeschaltung gewesen sein.
                <br />
                <strong class="adsimple-121283491">Ablaufdatum:</strong>
                nach 6 Monaten
            </p>
            <p>
                <strong class="adsimple-121283491">Name:</strong>
                __utmv
                <br />
                <strong class="adsimple-121283491">Wert:</strong>
                keine Angabe
                <br />
                <strong class="adsimple-121283491">Verwendungszweck:</strong>
                Das Cookie wird verwendet, um benutzerdefinierte Userdaten zu
                speichern. Es wird immer aktualisiert, wenn Informationen an
                Google Analytics gesendet werden.
                <br />
                <strong class="adsimple-121283491">Ablaufdatum:</strong>
                nach 2 Jahren
            </p>
            <p>
                <strong class="adsimple-121283491">Anmerkung:</strong>
                Diese Aufzählung kann keinen Anspruch auf Vollständigkeit
                erheben, da Google die Wahl ihrer Cookies immer wieder auch
                verändert.
            </p>
            <p>
                Hier zeigen wir Ihnen einen Überblick über die wichtigsten
                Daten, die mit Google Analytics erhoben werden:
            </p>
            <p>
                <strong class="adsimple-121283491">Heatmaps:</strong>
                Google legt sogenannte Heatmaps an. Über Heatmaps sieht man
                genau jene Bereiche, die Sie anklicken. So bekommen wir
                Informationen, wo Sie auf unserer Seite „unterwegs“ sind.
            </p>
            <p>
                <strong class="adsimple-121283491">Sitzungsdauer:</strong>
                Als Sitzungsdauer bezeichnet Google die Zeit, die Sie auf
                unserer Seite verbringen, ohne die Seite zu verlassen. Wenn Sie
                20 Minuten inaktiv waren, endet die Sitzung automatisch.
            </p>
            <p>
                <strong class="adsimple-121283491">Absprungrate</strong>
                (engl. Bouncerate): Von einem Absprung ist die Rede, wenn Sie
                auf unserer Website nur eine Seite ansehen und dann unsere
                Website wieder verlassen.
            </p>
            <p>
                <strong class="adsimple-121283491">Kontoerstellung:</strong>
                Wenn Sie auf unserer Website ein Konto erstellen bzw. eine
                Bestellung machen, erhebt Google Analytics diese Daten.
            </p>
            <p>
                <strong class="adsimple-121283491">IP-Adresse:</strong>
                Die IP-Adresse wird nur in gekürzter Form dargestellt, damit
                keine eindeutige Zuordnung möglich ist.
            </p>
            <p>
                <strong class="adsimple-121283491">Standort:</strong>
                Über die IP-Adresse kann das Land und Ihr ungefährer Standort
                bestimmt werden. Diesen Vorgang bezeichnet man auch als IP-
                Standortbestimmung.
            </p>
            <p>
                <strong class="adsimple-121283491">
                    Technische Informationen:
                </strong>
                Zu den technischen Informationen zählen unter anderem Ihr
                Browsertyp, Ihr Internetanbieter oder Ihre Bildschirmauflösung.
            </p>
            <p>
                <strong class="adsimple-121283491">Herkunftsquelle:</strong>
                Google Analytics beziehungsweise uns interessiert natürlich auch
                über welche Website oder welche Werbung Sie auf unsere Seite
                gekommen sind.
            </p>
            <p>
                Weitere Daten sind Kontaktdaten, etwaige Bewertungen, das
                Abspielen von Medien (z.B., wenn Sie ein Video über unsere Seite
                abspielen), das Teilen von Inhalten über Social Media oder das
                Hinzufügen zu Ihren Favoriten. Die Aufzählung hat keinen
                Vollständigkeitsanspruch und dient nur zu einer allgemeinen
                Orientierung der Datenspeicherung durch Google Analytics.
            </p>
            <h3 class="adsimple-121283491">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Google hat Ihre Server auf der ganzen Welt verteilt. Die meisten
                Server befinden sich in Amerika und folglich werden Ihre Daten
                meist auf amerikanischen Servern gespeichert. Hier können Sie
                genau nachlesen wo sich die Google-Rechenzentren befinden:
                <a
                    class="adsimple-121283491"
                    href="https://www.google.com/about/datacenters/inside/locations/?hl=de"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    https://www.google.com/about/datacenters/inside/locations/?hl=de
                </a>
            </p>
            <p>
                Ihre Daten werden auf verschiedenen physischen Datenträgern
                verteilt. Das hat den Vorteil, dass die Daten schneller abrufbar
                sind und vor Manipulation besser geschützt sind. In jedem
                Google-Rechenzentrum gibt es entsprechende Notfallprogramme für
                Ihre Daten. Wenn beispielsweise die Hardware bei Google ausfällt
                oder Naturkatastrophen Server lahmlegen, bleibt das Risiko einer
                Dienstunterbrechung bei Google dennoch gering.
            </p>
            <p>
                Standardisiert ist bei Google Analytics eine Aufbewahrungsdauer
                Ihrer Userdaten von 26 Monaten eingestellt. Dann werden Ihre
                Userdaten gelöscht. Allerdings haben wir die Möglichkeit, die
                Aufbewahrungsdauer von Nutzdaten selbst zu wählen. Dafür stehen
                uns fünf Varianten zur Verfügung:
            </p>
            <ul class="adsimple-121283491">
                <li class="adsimple-121283491">Löschung nach 14 Monaten</li>
                <li class="adsimple-121283491">Löschung nach 26 Monaten</li>
                <li class="adsimple-121283491">Löschung nach 38 Monaten</li>
                <li class="adsimple-121283491">Löschung nach 50 Monaten</li>
                <li class="adsimple-121283491">Keine automatische Löschung</li>
            </ul>
            <p>
                Wenn der festgelegte Zeitraum abgelaufen ist, werden einmal im
                Monat die Daten gelöscht. Diese Aufbewahrungsdauer gilt für Ihre
                Daten, die mit Cookies, Usererkennung und Werbe-IDs (z.B.
                Cookies der DoubleClick-Domain) verknüpft sind.
                Berichtergebnisse basieren auf aggregierten Daten und werden
                unabhängig von Nutzerdaten gespeichert. Aggregierte Daten sind
                eine Zusammenschmelzung von Einzeldaten zu einer größeren
                Einheit.
            </p>
            <h3 class="adsimple-121283491">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung
                verhindern?
            </h3>
            <p>
                Nach dem Datenschutzrecht der Europäischen Union haben Sie das
                Recht, Auskunft über Ihre Daten zu erhalten, sie zu
                aktualisieren, zu löschen oder einzuschränken. Mithilfe des
                Browser-Add-ons zur Deaktivierung von Google
                Analytics-JavaScript (ga.js, analytics.js, dc.js) verhindern
                Sie, dass Google Analytics Ihre Daten verwendet. Das
                Browser-Add-on können Sie unter
                <a
                    class="adsimple-121283491"
                    href="https://tools.google.com/dlpage/gaoptout?hl=de"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    https://tools.google.com/dlpage/gaoptout?hl=de
                </a>
                runterladen und installieren. Beachten Sie bitte, dass durch
                dieses Add-on nur die Datenerhebung durch Google Analytics
                deaktiviert wird.
            </p>
            <p>
                Falls Sie grundsätzlich Cookies (unabhängig von Google
                Analytics) deaktivieren, löschen oder verwalten wollen, gibt es
                für jeden Browser eine eigene Anleitung:
            </p>
            <p>
                <a
                    class="adsimple-121283491"
                    href="https://support.google.com/chrome/answer/95647?tid=121283491"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Chrome: Cookies in Chrome löschen, aktivieren und verwalten
                </a>
            </p>
            <p>
                <a
                    class="adsimple-121283491"
                    href="https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=121283491"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Safari: Verwalten von Cookies und Websitedaten mit Safari
                </a>
            </p>
            <p>
                <a
                    class="adsimple-121283491"
                    href="https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=121283491"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Firefox: Cookies löschen, um Daten zu entfernen, die
                    Websites auf Ihrem Computer abgelegt haben
                </a>
            </p>
            <p>
                <a
                    class="adsimple-121283491"
                    href="https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=121283491"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Internet Explorer: Löschen und Verwalten von Cookies
                </a>
            </p>
            <p>
                <a
                    class="adsimple-121283491"
                    href="https://support.microsoft.com/de-at/help/4027947/windows-delete-cookies?tid=121283491"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Microsoft Edge: Löschen und Verwalten von Cookies
                </a>
            </p>
            <p>
                Google Analytics ist aktiver Teilnehmer beim EU-U.S. Privacy
                Shield Framework, wodurch der korrekte und sichere Datentransfer
                persönlicher Daten geregelt wird. Mehr Informationen dazu finden
                Sie auf
                <a
                    class="adsimple-121283491"
                    href="https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI"
                    target="_blank"
                    rel="follow noopener noreferrer"
                >
                    https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&tid=121283491
                </a>
                . Wir hoffen wir konnten Ihnen die wichtigsten Informationen
                rund um die Datenverarbeitung von Google Analytics näherbringen.
                Wenn Sie mehr über den Tracking-Dienst erfahren wollen,
                empfehlen wir diese beiden Links:
                <a
                    class="adsimple-121283491"
                    href="http://www.google.com/analytics/terms/de.html"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    http://www.google.com/analytics/terms/de.html
                </a>
                und
                <a
                    class="adsimple-121283491"
                    href="https://support.google.com/analytics/answer/6004245?hl=de"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    https://support.google.com/analytics/answer/6004245?hl=de
                </a>
                .
            </p>
            <h2
                id="google-analytics-ip-anonymisierung"
                class="adsimple-121283491"
            >
                Google Analytics IP-Anonymisierung
            </h2>
            <p>
                Wir haben auf dieser Webseite die IP-Adressen-Anonymisierung von
                Google Analytics implementiert. Diese Funktion wurde von Google
                entwickelt, damit diese Webseite die geltenden
                Datenschutzbestimmungen und Empfehlungen der lokalen
                Datenschutzbehörden einhalten kann, wenn diese eine Speicherung
                der vollständigen IP-Adresse untersagen. Die Anonymisierung bzw.
                Maskierung der IP findet statt, sobald die IP-Adressen im Google
                Analytics-Datenerfassungsnetzwerk eintreffen und bevor eine
                Speicherung oder Verarbeitung der Daten stattfindet.
            </p>
            <p>
                Mehr Informationen zur IP-Anonymisierung finden Sie auf
                <a
                    class="adsimple-121283491"
                    href="https://support.google.com/analytics/answer/2763052?hl=de"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    https://support.google.com/analytics/answer/2763052?hl=de
                </a>
                .
            </p>
            <h2
                id="google-analytics-berichte-zu-demografischen-merkmalen-und-interessen"
                class="adsimple-121283491"
            >
                Google Analytics Berichte zu demografischen Merkmalen und
                Interessen
            </h2>
            <p>
                Wir haben in Google Analytics die Funktionen für Werbeberichte
                eingeschaltet. Die Berichte zu demografischen Merkmalen und
                Interessen enthalten Angaben zu Alter, Geschlecht und
                Interessen. Damit können wir uns – ohne diese Daten einzelnen
                Personen zuordnen zu können – ein besseres Bild von unseren
                Nutzern machen. Mehr über die Werbefunktionen erfahren Sie
                <a
                    class="adsimple-121283491"
                    href="https://support.google.com/analytics/answer/3450482?hl=de_AT&utm_id=ad"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    auf
                    https://support.google.com/analytics/answer/3450482?hl=de_AT&utm_id=ad
                </a>
                .
            </p>
            <p>
                Sie können die Nutzung der Aktivitäten und Informationen Ihres
                Google Kontos unter “Einstellungen für Werbung” auf
                <a
                    class="adsimple-121283491"
                    href="https://adssettings.google.com/authenticated"
                >
                    https://adssettings.google.com/authenticated
                </a>
                per Checkbox beenden.
            </p>
            <h2
                id="google-analytics-deaktivierungslink"
                class="adsimple-121283491"
            >
                Google Analytics Deaktivierungslink
            </h2>
            <p>
                Wenn Sie auf folgenden
                <strong class="adsimple-121283491">Deaktivierungslink</strong>
                klicken, können Sie verhindern, dass Google weitere Besuche auf
                dieser Website erfasst. Achtung: Das Löschen von Cookies, die
                Nutzung des Inkognito/Privatmodus ihres Browsers, oder die
                Nutzung eines anderen Browsers führt dazu, dass wieder Daten
                erhoben werden.
            </p>
            <p>
                <a class="adsimple-121283491">Google Analytics deaktivieren</a>
            </p>
            <h2
                id="google-analytics-zusatz-zur-datenverarbeitung"
                class="adsimple-121283491"
            >
                Google Analytics Zusatz zur Datenverarbeitung
            </h2>
            <p>
                Wir haben mit Google einen Direktkundenvertrag zur Verwendung
                von Google Analytics abgeschlossen, indem wir den “Zusatz zur
                Datenverarbeitung” in Google Analytics akzeptiert haben.
            </p>
            <p>
                Mehr über den Zusatz zur Datenverarbeitung für Google Analytics
                finden Sie hier:
                <a
                    class="adsimple-121283491"
                    href="https://support.google.com/analytics/answer/3379636?hl=de&utm_id=ad"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    https://support.google.com/analytics/answer/3379636?hl=de&utm_id=ad
                </a>
            </p>
            <h2
                id="google-analytics-google-signale-datenschutzerklaerung"
                class="adsimple-121283491"
            >
                Google Analytics Google-Signale Datenschutzerklärung
            </h2>
            <p>
                Wir haben in Google Analytics die Google-Signale aktiviert. So
                werden die bestehenden Google-Analytics-Funktionen
                (Werbeberichte, Remarketing, gerätübergreifende Berichte und
                Berichte zu Interessen und demografische Merkmale) aktualisiert,
                um zusammengefasste und anonymisierte Daten von Ihnen zu
                erhalten, sofern Sie personalisierte Anzeigen in Ihrem
                Google-Konto erlaubt haben.
            </p>
            <p>
                Das besondere daran ist, dass es sich dabei um ein
                Cross-Device-Tracking handelt. Das heißt Ihre Daten können
                geräteübergreifend analysiert werden. Durch die Aktivierung von
                Google-Signale werden Daten erfasst und mit dem Google-Konto
                verknüpft. Google kann dadurch zum Beispiel erkennen, wenn Sie
                auf unsere Webseite über ein Smartphone ein Produkt ansehen und
                erst später über einen Laptop das Produkt kaufen. Dank der
                Aktivierung von Google-Signale können wir gerätübergreifende
                Remarketing-Kampagnen starten, die sonst in dieser Form nicht
                möglich wären. Remarketing bedeutet, dass wir Ihnen auch auf
                anderen Webseiten unser Angebot zeigen können.
            </p>
            <p>
                In Google Analytics werden zudem durch die Google-Signale
                weitere Besucherdaten wie Standort, Suchverlauf, YouTube-Verlauf
                und Daten über Ihre Handlungen auf unserer Webseite, erfasst.
                Wir erhalten dadurch von Google bessere Werbeberichte und
                nützlichere Angaben zu Ihren Interessen und demografischen
                Merkmalen. Dazu gehören Ihr Alter, welche Sprache sie sprechen,
                wo Sie wohnen oder welchem Geschlecht Sie angehören. Weiters
                kommen auch noch soziale Kriterien wie Ihr Beruf, Ihr
                Familienstand oder Ihr Einkommen hinzu. All diese Merkmal helfen
                Google Analytics Personengruppen bzw. Zielgruppen zu definieren.
            </p>
            <p>
                Die Berichte helfen uns auch Ihr Verhalten, Ihre Wünsche und
                Interessen besser einschätzen zu können. Dadurch können wir
                unsere Dienstleistungen und Produkte für Sie optimieren und
                anpassen. Diese Daten laufen standardmäßig nach 26 Monaten ab.
                Bitte beachten Sie, dass diese Datenerfassung nur erfolgt, wenn
                Sie personalisierte Werbung in Ihrem Google-Konto zugelassen
                haben. Es handelt sich dabei immer um zusammengefasste und
                anonyme Daten und nie um Daten einzelner Personen. In Ihrem
                Google-Konto können Sie diese Daten verwalten bzw. auch löschen.
            </p>
            <h2
                id="google-tag-manager-datenschutzerklaerung"
                class="adsimple-121283491"
            >
                Google Tag Manager Datenschutzerklärung
            </h2>
            <p>
                Für unsere Website verwenden wir den Google Tag Manager des
                Unternehmens Google Inc. Für den europäischen Raum ist das
                Unternehmen Google Ireland Limited (Gordon House, Barrow Street
                Dublin 4, Irland) für alle Google-Dienste verantwortlich. Dieser
                Tag Manager ist eines von vielen hilfreichen Marketing-Produkten
                von Google. Über den Google Tag Manager können wir
                Code-Abschnitte von diversen Trackingtools, die wir auf unserer
                Webseite verwenden, zentral einbauen und verwalten.
            </p>
            <p>
                In dieser Datenschutzerklärung wollen wir Ihnen genauer erklären
                was der Google Tag Manager macht, warum wir ihn verwenden und in
                welcher Form Daten verarbeitet werden.
            </p>
            <h3 class="adsimple-121283491">Was ist der Google Tag Manager?</h3>
            <p>
                Der Google Tag Manager ist ein Organisationstool, mit dem wir
                Webseiten-Tags zentral und über eine Benutzeroberfläche
                einbinden und verwalten können. Als Tags bezeichnet man kleine
                Code-Abschnitte, die beispielsweise Ihre Aktivitäten auf unserer
                Webseite aufzeichnen (tracken). Dafür werden
                JavaScript-Code-Abschnitte in den Quelltext unserer Seite
                eingesetzt. Die Tags stammen oft von google-internen Produkten
                wie Google Ads oder Google Analytics, aber auch Tags von anderen
                Unternehmen können über den Manager eingebunden und verwaltet
                werden. Solche Tags übernehmen unterschiedliche Aufgaben. Sie
                können Browserdaten sammeln, Marketingtools mit Daten füttern,
                Buttons einbinden, Cookies setzen und auch Nutzer über mehrere
                Webseiten hinweg verfolgen.
            </p>
            <h3 class="adsimple-121283491">
                Warum verwenden wir den Google Tag Manager für unserer Webseite?
            </h3>
            <p>
                Wie sagt man so schön: Organisation ist die halbe Miete! Und das
                betrifft natürlich auch die Pflege unserer Webseite. Um unsere
                Webseite für Sie und alle Menschen, die sich für unsere Produkte
                und Dienstleistungen interessieren, so gut wie möglich zu
                gestalten, brauchen wir diverse Trackingtools wie beispielsweise
                Google Analytics. Die erhobenen Daten dieser Tools zeigen uns,
                was Sie am meisten interessiert, wo wir unsere Leistungen
                verbessern können und welchen Menschen wir unsere Angebote noch
                zeigen sollten. Und damit dieses Tracking funktioniert, müssen
                wir entsprechende JavaScript-Codes in unsere Webseite einbinden.
                Grundsätzlich könnten wir jeden Code-Abschnitt der einzelnen
                Tracking-Tools separat in unseren Quelltext einbauen. Das
                erfordert allerdings relativ viel Zeit und man verliert leicht
                den Überblick. Darum nützen wir den Google Tag Manager. Wir
                können die nötigen Skripte einfach einbauen und von einem Ort
                aus verwalten. Zudem bietet der Google Tag Manager eine leicht
                zu bedienende Benutzeroberfläche und man benötigt keine
                Programmierkenntnisse. So schaffen wir es, Ordnung in unserem
                Tag-Dschungel zu halten.
            </p>
            <h3 class="adsimple-121283491">
                Welche Daten werden vom Google Tag Manager gespeichert?
            </h3>
            <p>
                Der Tag Manager selbst ist eine Domain, die keine Cookies setzt
                und keine Daten speichert. Er fungiert als bloßer „Verwalter“
                der implementierten Tags. Die Daten erfassen die einzelnen Tags
                der unterschiedlichen Web-Analysetools. Die Daten werden im
                Google Tag Manager quasi zu den einzelnen Tracking-Tools
                durchgeschleust und nicht gespeichert.
            </p>
            <p>
                Ganz anders sieht das allerdings mit den eingebundenen Tags der
                verschiedenen Web-Analysetools, wie zum Beispiel Google
                Analytics, aus. Je nach Analysetool werden meist mit Hilfe von
                Cookies verschiedene Daten über Ihr Webverhalten gesammelt,
                gespeichert und verarbeitet. Dafür lesen Sie bitte unsere
                Datenschutztexte zu den einzelnen Analyse- und Trackingtools,
                die wir auf unserer Webseite verwenden.
            </p>
            <p>
                In den Kontoeinstellungen des Tag Managers haben wir Google
                erlaubt, dass Google anonymisierte Daten von uns erhält. Dabei
                handelt es sich aber nur um die Verwendung und Nutzung unseres
                Tag Managers und nicht um Ihre Daten, die über die
                Code-Abschnitte gespeichert werden. Wir ermöglichen Google und
                anderen, ausgewählte Daten in anonymisierter Form zu erhalten.
                Wir stimmen somit der anonymen Weitergabe unseren Website-Daten
                zu. Welche zusammengefassten und anonymen Daten genau
                weitergeleitet werden, konnten wir – trotz langer Recherche –
                nicht in Erfahrung bringen. Auf jeden Fall löscht Google dabei
                alle Infos, die unsere Webseite identifizieren könnten. Google
                fasst die Daten mit Hunderten anderen anonymen Webseiten-Daten
                zusammen und erstellt, im Rahmen von Benchmarking-Maßnahmen,
                Usertrends. Bei Benchmarking werden eigene Ergebnisse mit jenen
                der Mitbewerber verglichen. Auf Basis der erhobenen
                Informationen können Prozesse optimiert werden.
            </p>
            <h3 class="adsimple-121283491">
                Wie lange und wo werden die Daten gespeichert?
            </h3>
            <p>
                Wenn Google Daten speichert, dann werden diese Daten auf den
                eigenen Google-Servern gespeichert. Die Server sind auf der
                ganzen Welt verteilt. Die meisten befinden sich in Amerika.
                Unter
                <a
                    class="adsimple-121283491"
                    href="https://www.google.com/about/datacenters/inside/locations/?hl=de"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    https://www.google.com/about/datacenters/inside/locations/?hl=de
                </a>
                können Sie genau nachlesen, wo sich die Google-Server befinden.
            </p>
            <p>
                Wie lange die einzelnen Tracking-Tools Daten von Ihnen
                speichern, entnehmen Sie unseren individuellen Datenschutztexten
                zu den einzelnen Tools.
            </p>
            <h3 class="adsimple-121283491">
                Wie kann ich meine Daten löschen bzw. die Datenspeicherung
                verhindern?
            </h3>
            <p>
                Der Google Tag Manager selbst setzt keine Cookies, sondern
                verwaltet Tags verschiedener Tracking-Webseiten. In unseren
                Datenschutztexten zu den einzelnen Tracking-Tools, finden Sie
                detaillierte Informationen wie Sie Ihre Daten löschen bzw.
                verwalten können.
            </p>
            <p>
                Google ist aktiver Teilnehmer beim EU-U.S. Privacy Shield
                Framework, wodurch der korrekte und sichere Datentransfer
                persönlicher Daten geregelt wird. Mehr Informationen dazu finden
                Sie auf
                <a
                    class="adsimple-121283491"
                    href="https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&tid=121283491
                </a>
                . Wenn Sie mehr über den Google Tag Manager erfahren wollen,
                empfehlen wir Ihnen die FAQs unter
                <a
                    class="adsimple-121283491"
                    href="https://www.google.com/intl/de/tagmanager/faq.html"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    https://www.google.com/intl/de/tagmanager/faq.html
                </a>
                .
            </p>
            <h2
                id="eingebettete-social-media-elemente-datenschutzerklaerung"
                class="adsimple-121283491"
            >
                Eingebettete Social Media Elemente Datenschutzerklärung
            </h2>
            <p>
                Wir binden auf unserer Webseite Elemente von Social Media
                Diensten ein um Bilder, Videos und Texte anzuzeigen.
                <br />
                Durch den Besuch von Seiten die diese Elemente darstellen,
                werden Daten von Ihrem Browser zum jeweiligen Social Media
                Dienst übertragen und dort gespeichert. Wir haben keinen Zugriff
                auf diese Daten.
                <br />
                Die folgenden Links führen Sie zu den Seiten der jeweiligen
                Social Media Dienste wo erklärt wird, wie diese mit Ihren Daten
                umgehen:
            </p>
            <ul class="adsimple-121283491">
                <li class="adsimple-121283491">
                    Instagram-Datenschutzrichtlinie:
                    <a
                        class="adsimple-121283491"
                        href="https://help.instagram.com/519522125107875?tid=121283491"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        https://help.instagram.com/519522125107875
                    </a>
                </li>
                <li class="adsimple-121283491">
                    Für YouTube gilt die Google Datenschutzerklärung:
                    <a
                        class="adsimple-121283491"
                        href="https://policies.google.com/privacy?hl=de&tid=121283491"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        https://policies.google.com/privacy?hl=de
                    </a>
                </li>
                <li class="adsimple-121283491">
                    Facebook-Datenrichtline:
                    <a
                        class="adsimple-121283491"
                        href="https://www.facebook.com/about/privacy?tid=121283491"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        https://www.facebook.com/about/privacy
                    </a>
                </li>
                <li class="adsimple-121283491">
                    Twitter Datenschutzrichtlinie:
                    <a
                        class="adsimple-121283491"
                        href="https://twitter.com/de/privacy?tid=121283491"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        https://twitter.com/de/privacy
                    </a>
                </li>
            </ul>
            <p style="margin-top: 15px">
                Quelle: Erstellt mit dem Datenschutz Generator von
                <a
                    href="https://www.adsimple.at/"
                    title="AdSimple® Online Marketing und Webdesign"
                    rel="follow noopener noreferrer"
                    target="_blank"
                >
                    AdSimple®
                </a>
                in Kooperation mit
                <a
                    href="https://www.bauguide.at/"
                    target="_blank"
                    rel="follow noopener noreferrer"
                >
                    bauguide.at
                </a>
            </p>

            <hr class="mt-5 mb-5" />
            <div id="english-version"></div>

            <h1 class="adsimple-121283491">Imprint</h1>
            <p class="adsimple-121283491">
                Information in accordance with §5 of the E-Commerce Act, §14 of
                the Unternehmensgesetzbuch, §63 of the Commercial Code and
                disclosure requirements under §25 of the Media Act.
            </p>
            <p class="adsimple-121283491"></p>
            <p>Raphael Bernhart</p>
            <p class="adsimple-121283491">
                Achenweg 30, Top 4,
                <br />
                6364 Brixen im Thale,
                <br />
                Österreich
            </p>
            <p class="adsimple-121283491">
                <strong>Phone:</strong>
                +43 664 860 65 67
                <br />
                <strong>Email:</strong>
                <a href="mailto:mail@raphaelbernhart.at">
                    mail@raphaelbernhart.at
                </a>
            </p>
            <p style="margin-top: 15px">
                Source: Created with the Impressum Generator by
                <a
                    href="https://www.adsimple.at/linkbuilding-backlinkaufbau/"
                    title="AdSimple® Linkbuilding"
                    rel="follow"
                    target="_blank"
                >
                    AdSimple® Linkbuilding
                </a>
                in cooperation with
                <a href="https://www.bauguide.at/" target="_blank" rel="follow">
                    bauguide.at
                </a>
            </p>
            <h2 id="eu-streitschlichtung-en" class="adsimple-121283491"></h2>
            <h2
                id="haftung-fuer-inhalte-dieser-webseite-en"
                class="adsimple-121283491"
            ></h2>
            <h2 id="haftung-links-webseite-en" class="adsimple-121283491"></h2>
            <h2 id="urheberrechtshinweis-en" class="adsimple-121283491"></h2>
            <h2 id="bildernachweis-en" class="adsimple-121283491"></h2>
            <h1 class="adsimple-121283491">Privacy policy</h1>
            <h2>Table of Contents</h2>
            <ul>
                <li>
                    <a href="#datenschutz-en">Privacy Policy</a>
                </li>
                <li>
                    <a href="#automatische-datenspeicherung-en">
                        Automatic Data Retention
                    </a>
                </li>
                <li>
                    <a href="#cookies-en">Cookies</a>
                </li>
                <li>
                    <a href="#rechte-dsgvo-en">
                        Rights in accordance with the General Data Protection
                        Regulation
                    </a>
                </li>
                <li>
                    <a href="#auswertung-des-besucherverhaltens-en">
                        Evaluation of Visitor Behaviour
                    </a>
                </li>
                <li>
                    <a href="#tls-verschluesselung-https-en">
                        TLS encryption with https
                    </a>
                </li>
                <li>
                    <a href="#google-fonts-datenschutzerklaerung-en">
                        Google Fonts Privacy Policy
                    </a>
                </li>
                <li>
                    <a href="#google-fonts-lokal-datenschutzerklaerung-en">
                        Google Fonts Local Privacy Policy
                    </a>
                </li>
                <li>
                    <a href="#google-analytics-datenschutzerklaerung-en">
                        Google Analytics Privacy Policy
                    </a>
                </li>
                <li>
                    <a href="#google-analytics-ip-anonymisierung-en">
                        Google Analytics IP Anonymisation
                    </a>
                </li>
                <li>
                    <a
                        href="#google-analytics-berichte-zu-demografischen-merkmalen-und-interessen-en"
                    >
                        Google Analytics Reports on demographic characteristics
                        and interests
                    </a>
                </li>
                <li>
                    <a href="#google-analytics-deaktivierungslink-en">
                        Google Analytics Deactivation Link
                    </a>
                </li>
                <li>
                    <a href="#google-analytics-zusatz-zur-datenverarbeitung-en">
                        Google Analytics' Data Processing Amendment
                    </a>
                </li>
                <li>
                    <a
                        href="#google-analytics-google-signale-datenschutzerklaerung-en"
                    >
                        Google Analytics Google Signals Privacy Policy
                    </a>
                </li>
                <li>
                    <a href="#google-tag-manager-datenschutzerklaerung-en">
                        Google Tag Manager Privacy Policy
                    </a>
                </li>
                <li>
                    <a
                        href="#eingebettete-social-media-elemente-datenschutzerklaerung-en"
                    >
                        Embedded Social Media elements Privacy Policy
                    </a>
                </li>
            </ul>
            <h2 id="datenschutz-en" class="adsimple-121283491">
                Privacy Policy
            </h2>
            <p>
                We created this Privacy Policy (version 01.01.1970-121283491),
                to declare which information we collect, how we use data and
                which options the users of our website have, according to the
                guidelines of the
                <a
                    class="adsimple-121283491"
                    href="https://eur-lex.europa.eu/legal-content/EN/ALL/?uri=celex%3A32016R0679&amp%3Btid= 121283491"
                    target="_blank"
                    rel="noopener"
                >
                    General Data Protection Regulation (EU) 2016/679
                </a>
            </p>
            <p>
                Unfortunately, these subjects sound rather technical due to
                their nature, but we have put much effort into describing the
                most important things as simply and clearly as possible.
            </p>
            <h2
                id="automatische-datenspeicherung-en"
                class="adsimple-121283491"
            >
                Automatic Data Retention
            </h2>
            <p>
                Every time you visit a website nowadays, certain information is
                automatically created and saved, just as it happens on this
                website.
            </p>
            <p>
                Whenever you visit our website such as you are doing right now,
                our webserver (computer on which this website is saved/stored)
                automatically saves data such as
            </p>
            <ul class="adsimple-121283491">
                <li class="adsimple-121283491">
                    the address (URL) of the accessed website
                </li>
                <li class="adsimple-121283491">browser and browser version</li>
                <li class="adsimple-121283491">the used operating system</li>
                <li class="adsimple-121283491">
                    the address (URL) of the previously visited site (referrer
                    URL)
                </li>
                <li class="adsimple-121283491">
                    the host name and the IP-address of the device the website
                    is accessed from
                </li>
                <li class="adsimple-121283491">date and time</li>
            </ul>
            <p>in files (webserver-logfiles).</p>
            <p>
                Generally, webserver-logfiles stay saved for two weeks and then
                get deleted automatically. We do not pass this information to
                others, but we cannot exclude the possibility that this data
                will be looked at in case of illegal conduct.
            </p>
            <h2 id="cookies-en" class="adsimple-121283491">Cookies</h2>
            <p>
                Our website uses HTTP-cookies to store user-specific data.
                <br />
                For your better understanding of the following Privacy Policy
                statement, we will explain to you below what cookies are and why
                they are in use.
            </p>
            <h3 class="adsimple-121283491">What exactly are cookies?</h3>
            <p>
                Every time you surf the internet, you use a browser. Common
                browsers are for example Chrome, Safari, Firefox, Internet
                Explorer and Microsoft Edge. Most websites store small
                text-files in your browser. These files are called cookies.
            </p>
            <p>
                What should not be dismissed, is that cookies are very useful
                little helpers. Nearly all websites use cookies. More accurately
                speaking these are HTTP-cookies, since there are also different
                cookies for other uses. http-cookies are small files which our
                website stores on your computer. These cookie files are
                automatically put into the cookie-folder, which is like the
                “brain” of your browser. A cookie consists of a name and a
                value. Moreover, to define a cookie, one or multiple attributes
                must be specified.
            </p>
            <p>
                Cookies save certain parts of your user data, such as e.g.
                language or personal page settings. When you re-open our
                website, your browser submits these “user specific” information
                back to our site. Thanks to cookies, our website knows who you
                are and offers you the settings you are familiar to. In some
                browsers every cookie has its own file, in others such as
                Firefox, all cookies are stored in one single file.
            </p>
            <p>
                There are both first-party cookies and third-party coookies.
                First-party cookies are created directly by our site, while
                third-party cookies are created by partner-websites (e.g. Google
                Analytics). Every cookie is individual, since every cookie
                stores different data. The expiration time of a cookie also
                varies – it can be a few minutes, or up to a few years. Cookies
                are no software-programs and contain no computer viruses,
                trojans or any other malware. Cookies also cannot access your
                PC’s information.
            </p>
            <p>This is an example of how cookie-files can look:</p>
            <p>
                <strong class="adsimple-121283491">name:</strong>
                _ga
                <br />
                <strong class="adsimple-121283491">value:</strong>
                GA1.2.1326744211.152121283491-9
                <br />
                <strong class="adsimple-121283491">purpose:</strong>
                differentiation between website visitors
                <br />
                <strong class="adsimple-121283491">expiration date:</strong>
                after 2 years
            </p>
            <p>A browser should support these minimum sizes:</p>
            <ul class="adsimple-121283491">
                <li class="adsimple-121283491">
                    at least 4096 bytes per cookie
                </li>
                <li class="adsimple-121283491">
                    at least 50 cookies per domain
                </li>
                <li class="adsimple-121283491">
                    at least 3000 cookies in total
                </li>
            </ul>
            <h3 class="adsimple-121283491">
                Which types of cookies are there?
            </h3>
            <p>
                What exact cookies we use, depends on the used services. We will
                explain this in the following sections of the Privacy Policy
                statement. Firstly, we will briefly focus on the different types
                of HTTP-cookies.
            </p>
            <p>There are 4 different types of cookies:</p>
            <p>
                <strong class="adsimple-121283491">
                    Essential Cookies
                    <br />
                </strong>
                These cookies are necessary to ensure the basic function of a
                website. They are needed when a user for example puts a product
                into their shopping cart, then continues surfing on different
                websites and comes back later in order to proceed to the
                checkout. Even when the user closed their window priorly, these
                cookies ensure that the shopping cart does not get deleted.
            </p>
            <p>
                <strong class="adsimple-121283491">
                    Purposive Cookies
                    <br />
                </strong>
                These cookies collect info about the user behaviour and record
                if the user potentially receives any error messages.
                Furthermore, these cookies record the website’s loading time as
                well as its behaviour within different browsers.
            </p>
            <p>
                <strong class="adsimple-121283491">
                    Target-orientated Cookies
                    <br />
                </strong>
                These cookies care for an improved user-friendliness. Thus,
                information such as previously entered locations, fonts or data
                in forms stay saved.
            </p>
            <p>
                <strong class="adsimple-121283491">
                    Advertising Cookies
                    <br />
                </strong>
                These cookies are also known as targeting-Cookies. They serve
                the purpose of delivering individually adapted advertisements to
                the user. This can be very practical, but also rather annoying.
            </p>
            <p>
                Upon your first visit to a website you are usually asked which
                of these cookie-types you want to accept. Furthermore, this
                decision will of course also be saved in a cookie.
            </p>
            <h3 class="adsimple-121283491">How can I delete cookies?</h3>
            <p>
                You yourself take the decision if and how you want to use
                cookies. Thus, no matter what service or website cookies are
                from, you always have the option to delete, deactivate or only
                partially allow them. Therefore, you can for example block
                cookies of third parties but allow any other cookies.
            </p>
            <p>
                If you want change or delete cookie-settings and would like to
                determine which cookies have been saved to your browser, you can
                find this info in your browser-settings:
            </p>
            <p>
                <a
                    class="adsimple-121283491"
                    href="https://support.google.com/chrome/answer/95647?tid=121283491"
                    target="_blank"
                    rel="noopener"
                >
                    Chrome: Clear, enable and manage cookies in Chrome
                </a>
            </p>
            <p>
                <a
                    class="adsimple-121283491"
                    href="https://support.apple.com/en-gb/guide/safari/sfri11471/mac?tid=121283491"
                    target="_blank"
                    rel="noopener"
                >
                    Safari: Manage cookies and website data in Safari
                </a>
            </p>
            <p>
                <a
                    class="adsimple-121283491"
                    href=" https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox?tid=121283491"
                    target="_blank"
                    rel="noopener"
                >
                    Firefox: Clear cookies and site data in Firefox
                </a>
            </p>
            <p>
                <a
                    class="adsimple-121283491"
                    href=" https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies?tid=121283491"
                    target="_blank"
                    rel="noopener"
                >
                    Internet Explorer: Delete and manage cookies
                </a>
            </p>
            <p>
                <a
                    class="adsimple-121283491"
                    href=" https://support.microsoft.com/en-gb/help/4027947/microsoft-edge-delete-cookies?tid=121283491"
                    target="_blank"
                    rel="noopener"
                >
                    Microsoft Edge: Delete cookies in Microsoft Edge
                </a>
            </p>
            <p>
                If you generally do not want to allow any cookies at all, you
                can set up your browser in a way, to notify you whenever a
                potential cookie is about to be set. This gives you the
                opportunity to manually decide to either permit or deny the
                placement of every single cookie. The settings for this differ
                from browser to browser. Therefore, it might be best for you to
                search for the instructions in Google. If you are using Chrome,
                you could for example put the search phrase “delete cookies
                Chrome” or “deactivate cookies Chrome” into Google.
            </p>
            <h3 class="adsimple-121283491">How is my data protected?</h3>
            <p>
                There is a “cookie policy” that has been in place since 2009. It
                states that the storage of cookies requires the user’s consent.
                However, among the countries of the EU, these guidelines are
                often met with mixed reactions. In Austria the guidelines have
                been implemented in § 96 section 3 of the Telecommunications Act
                (TKG).
            </p>
            <p>
                If you want to learn more about cookies and do not mind
                technical documentation, we recommend
                <a
                    class="adsimple-121283491"
                    href="https://tools.ietf.org/html/rfc6265"
                    target="_blank"
                    rel="nofollow noopener"
                >
                    https://tools.ietf.org/html/rfc6265
                </a>
                , the Request for Comments of the Internet Engineering Task
                Force (IETF) called “HTTP State Management Mechanism”.
            </p>
            <h2 id="rechte-dsgvo-en" class="adsimple-121283491">
                Rights in accordance with the General Data Protection Regulation
            </h2>
            <p>
                You are granted the following rights in accordance with the
                provisions of the
                <a
                    class="adsimple-121283491"
                    href="https://gdpr-info.eu/"
                    target="_blank"
                    rel="noopener"
                >
                    GDPR
                </a>
                (General Data Protection Regulation) and the Austrian
                <a
                    class="adsimple-121283491"
                    href="https://www.ris.bka.gv.at/Dokumente/Erv/ERV_1999_1_165/ERV_1999_1_165.html"
                    target="_blank"
                    rel="noopener"
                >
                    Data Protection Act (DSG)
                </a>
                :
            </p>
            <ul class="adsimple-121283491">
                <li class="adsimple-121283491">
                    right to rectification (article 16 GDPR)
                </li>
                <li class="adsimple-121283491">
                    right to erasure (“right to be forgotten“) (article 17 GDPR)
                </li>
                <li class="adsimple-121283491">
                    right to restrict processing (article 18 GDPR)
                </li>
                <li class="adsimple-121283491">
                    righ to notification – notification obligation regarding
                    rectification or erasure of personal data or restriction of
                    processing (article 19 GDPR)
                </li>
                <li class="adsimple-121283491">
                    right to data portability (article 20 GDPR)
                </li>
                <li class="adsimple-121283491">
                    Right to object (article 21 GDPR)
                </li>
                <li class="adsimple-121283491">
                    right not to be subject to a decision based solely on
                    automated processing – including profiling – (article 22
                    GDPR)
                </li>
            </ul>
            <p>
                If you think that the processing of your data violates the data
                protection law, or that your data protection rights have been
                infringed in any other way, you can lodge a complaint with your
                respective regulatory authority. For Austria this is the data
                protection authority, whose website you can access at
                <a
                    class="adsimple-121283491"
                    href="https://www.data-protection-authority.gv.at/?tid=121283491"
                >
                    https://www.data-protection-authority.gv.at/
                </a>
                .
            </p>
            <h2
                id="auswertung-des-besucherverhaltens-en"
                class="adsimple-121283491"
            >
                Evaluation of Visitor Behaviour
            </h2>
            <p>
                In the following Privacy Policy, we will inform you on if and
                how we evaluate the data of your visit to this website. The
                evaluation is generally made anonymously, and we cannot link to
                you personally based on your behaviour on this website.
            </p>
            <p>
                You can find out more about how to disagree with the evaluation
                of visitor data, in the Privacy Policy below.
            </p>
            <h2 id="tls-verschluesselung-https-en" class="adsimple-121283491">
                TLS encryption with https
            </h2>
            <p>
                We use https to transfer information on the internet in a
                tap-proof manner (data protection through technology design
                <a
                    class="adsimple-121283491"
                    href="https://eur-lex.europa.eu/legal-content/en/TXT/HTML/?uri=CELEX:32016R0679&from=EN&tid=121283491"
                    target="_blank"
                    rel="noopener"
                >
                    Article 25 Section 1 GDPR
                </a>
                ). With the use of TLS (Transport Layer Security), which is an
                encryption protocol for safe data transfer on the internet, we
                can ensure the protection of confidential information. You can
                recognise the use of this safeguarding tool by the little
                lock-symbol, which is situated in your browser’s top left
                corner, as well as by the use of the letters https (instead of
                http) as a part of our web address.
            </p>
            <h2
                id="google-fonts-datenschutzerklaerung-en"
                class="adsimple-121283491"
            >
                Google Fonts Privacy Policy
            </h2>
            <p>
                On our website we use Google Fonts, from the company Google Inc.
                (1600 Amphitheatre Parkway Mountain View, CA 94043, USA).
            </p>
            <p>
                To use Google Fonts, you must log in and set up a password.
                Furthermore, no cookies will be saved in your browser. The data
                (CSS, Fonts) will be requested via the Google domains
                fonts.googleapis.com and fonts.gstatic.com. According to Google,
                all requests for CSS and fonts are fully separated from any
                other Google services. If you have a Google account, you do not
                need to worry that your Google account details are transmitted
                to Google while you use Google Fonts. Google records the use of
                CSS (Cascading Style Sheets) as well as the utilised fonts and
                stores these data securely. We will have a detailed look at how
                exactly the data storage works.
            </p>
            <h3 class="adsimple-121283491">What are Google Fonts?</h3>
            <p>
                Google Fonts (previously Google Web Fonts) is a list of over 800
                fonts which
                href=”https://en.wikipedia.org/wiki/Google?tid=121283491”>Google
                LLC provides its users for free.
            </p>
            <p>
                Many of these fonts have been published under the SIL Open Font
                License license, while others have been published under the
                Apache license. Both are free software licenses.
            </p>
            <h3 class="adsimple-121283491">
                Why do we use Google Fonts on our website?
            </h3>
            <p>
                With Google Fonts we can use different fonts on our website and
                do not have to upload them to our own server. Google Fonts is an
                important element which helps to keep the quality of our website
                high. All Google fonts are automatically optimised for the web,
                which saves data volume and is an advantage especially for the
                use of mobile terminal devices. When you use our website, the
                low data size provides fast loading times. Moreover, Google
                Fonts are secure Web Fonts. Various image synthesis systems
                (rendering) can lead to errors in different browsers, operating
                systems and mobile terminal devices. These errors could
                optically distort parts of texts or entire websites. Due to the
                fast Content Delivery Network (CDN) there are no cross-platform
                issues with Google Fonts. All common browsers (Google Chrome,
                Mozilla Firefox, Apple Safari, Opera) are supported by Google
                Fonts, and it reliably operates on most modern mobile operating
                systems, including Android 2.2+ and iOS 4.2+ (iPhone, iPad,
                iPod). We also use Google Fonts for presenting our entire online
                service as pleasantly and as uniformly as possible.
            </p>
            <h3 class="adsimple-121283491">Which data is saved by Google?</h3>
            <p>
                Whenever you visit our website, the fonts are reloaded by a
                Google server. Through this external cue, data gets transferred
                to Google’s servers. Therefore, this makes Google recognise that
                you (or your IP-address) is visiting our website. The Google
                Fonts API was developed to reduce the usage, storage and
                gathering of end user data to the minimum needed for the proper
                depiction of fonts. What is more, API stands for „Application
                Programming Interface“ and works as a software data
                intermediary.
            </p>
            <p>
                Google Fonts stores CSS and font requests safely with Google,
                and therefore it is protected. Using its collected usage
                figures, Google can determine how popular the individual fonts
                are. Google publishes the results on internal analysis pages,
                such as Google Analytics. Moreover, Google also utilises data of
                ist own web crawler, in order to determine which websites are
                using Google fonts. This data is published in Google Fonts’
                BigQuery database. Enterpreneurs and developers use Google’s
                webservice BigQuery to be able to inspect and move big volumes
                of data.
            </p>
            <p>
                One more thing that should be considered, is that every request
                for Google Fonts automatically transmits information such as
                language preferences, IP address, browser version, as well as
                the browser’s screen resolution and name to Google’s servers. It
                cannot be clearly identified if this data is saved, as Google
                has not directly declared it.
            </p>
            <h3 class="adsimple-121283491">
                How long and where is the data stored?
            </h3>
            <p>
                Google saves requests for CSS assets for one day in a tag on
                their servers, which are primarily located outside of the EU.
                This makes it possible for us to use the fonts by means of a
                Google stylesheet. With the help of a stylesheet, e.g. designs
                or fonts of a website can get changed swiftly and easily.
            </p>
            <p>
                Any font related data is stored with Google for one year. This
                is because Google’s aim is to fundamentally boost websites’
                loading times. With millions of websites referring to the same
                fonts, they are buffered after the first visit and instantly
                reappear on any other websites that are visited thereafter.
                Sometimes Google updates font files to either reduce the data
                sizes, increase the language coverage or to improve the design.
            </p>
            <h3 class="adsimple-121283491">
                How can I delete my data or prevent it being stored?
            </h3>
            <p>
                The data Google stores for either a day or a year cannot be
                deleted easily. Upon opening the page this data is automatically
                transmitted to Google. In order to clear the data ahead of time,
                you have to contact Google’s support at
                <a
                    class="adsimple-121283491"
                    href="https://support.google.com/?hl=en-GB&tid=121283491"
                >
                    https://support.google.com/?hl=en-GB&tid=121283491
                </a>
                . The only way for you to prevent the retention of your data is
                by not visiting our website.
            </p>
            <p>
                Unlike other web fonts, Google offers us unrestricted access to
                all its fonts. Thus, we have a vast sea of font types at our
                disposal, which helps us to get the most out of our website. You
                can find out more answers and information on Google Fonts at
                <a
                    class="adsimple-121283491"
                    href="https://developers.google.com/fonts/faq?tid=121283491"
                >
                    https://developers.google.com/fonts/faq?tid=121283491
                </a>
                . While Google does address relevant elements on data protection
                at this link, it does not contain any detailed information on
                data retention.
                <br />
                It proofs rather difficult to receive any precise information on
                stored data by Google.
            </p>
            <p>
                On
                <a
                    class="adsimple-121283491"
                    href="https://policies.google.com/privacy?hl=de&tid=121283491"
                >
                    https://policies.google.com/privacy?hl=en-GB
                </a>
                you can read more about what data is generally collected by
                Google and what this data is used for.
            </p>
            <h2
                id="google-fonts-lokal-datenschutzerklaerung-en"
                class="adsimple-121283491"
            >
                Google Fonts Local Privacy Policy
            </h2>
            <p>
                On our website we use Google Fonts, from the company Google Inc.
                (1600 Amphitheatre Parkway Mountain View, CA 94043, USA).
                <br />
                We integrated Google Fonts locally, so on our own webserver and
                not on Google’s servers. Hence, there is no connection to
                Google’s servers and consequently no data transfer or retention.
            </p>
            <h3 class="adsimple-121283491">What are Google Fonts?</h3>
            <p>
                Google Fonts was previously called Google Web Fonts. It is an
                interactive list with over 800 fonts which
                <a
                    class="adsimple-121283491"
                    href="https://en.wikipedia.org/wiki/Google?tid=121283491"
                >
                    Google LLC
                </a>
                offer for free use. With the use of Google Fonts, it is possible
                to utilise fonts without uploading them to your own server. For
                that matter, in order to prevent any transfer of information to
                Google’s servers, we downloaded the fonts to our own server.
                This way we comply with the data privacy and do not transmit any
                data to Google Fonts.
            </p>
            <p>
                Unlike other web fonts, Google offers us unrestricted access to
                all its fonts. Thus, we have a vast sea of font types at our
                disposal, which helps us to get the most out of our website. You
                can find out more answers and information on Google Fonts at
                <a
                    class="adsimple-121283491"
                    href="https://developers.google.com/fonts/faq?tid=121283491"
                >
                    https://developers.google.com/fonts/faq?tid=121283491
                </a>
                .
            </p>
            <h2
                id="google-analytics-datenschutzerklaerung-en"
                class="adsimple-121283491"
            >
                Google Analytics Privacy Policy
            </h2>
            <p>
                We use the tracking and analysis tool Google Analytics (GA) of
                the US-American company Google LLC (1600 Amphitheatre Parkway
                Mountain View, CA 94043, USA). Google Analytics collects data on
                your actions on our website. Whenever you click a link for
                example, this action is saved in a cookie and transferred to
                Google Analytics. With the help of reports which we receive from
                Google Analytics, we can adapt our website and our services
                better to your wishes. In the following, we will explain the
                tracking tool in more detail, and most of all, we will inform
                you what data is saved and how you can prevent this.
            </p>
            <h3 class="adsimple-121283491">What is Google Analytics?</h3>
            <p>
                Google Analytics is a tracking tool with the purpose of
                conducting data traffic analysis of our website. For Google
                Analytics to work, there is a tracking code integrated to our
                website. Upon your visit to our website, this code records
                various actions you perform on your website. As soon as you
                leave our website, this data is sent to the Google Analytics
                server, where it is stored.
            </p>
            <p>
                Google processes this data and we then receive reports on your
                user behaviour. These reports can be one of the following:
            </p>
            <ul class="adsimple-121283491">
                <li class="adsimple-121283491">
                    Target audience reports: With the help of target audience
                    reports we can get to know our users better and can
                    therefore better understand who is interested in our
                    service.
                </li>
                <li class="adsimple-121283491">
                    Advertising reports: Through advertising reports we can
                    analyse our online advertising better and hence improve it.
                </li>
                <li class="adsimple-121283491">
                    Acquisition reports: Acquisition reports provide us helpful
                    information on how we can get more people enthusiastic about
                    our service.
                </li>
                <li class="adsimple-121283491">
                    Behaviour reports: With these reports, we can find out how
                    you interact with our website. By the means of behaviour
                    reports, we can understand what path you go on our website
                    and what links you click.
                </li>
                <li class="adsimple-121283491">
                    Conversion reports: A conversion is the process of leading
                    you to carry out a desired action due to a marketing
                    message. An example of this would be transforming you from a
                    mere website visitor into a buyer or a newsletter
                    subscriber. Hence, with the help of these reports we can see
                    in more detail, if our marketing measures are successful
                    with you. Our aim is to increase our conversion rate.
                </li>
                <li class="adsimple-121283491">
                    Real time reports: With the help of these reports we can see
                    in real time, what happens on our website. It makes us for
                    example see, we can see how many users are reading this text
                    right now.
                </li>
            </ul>
            <h3 class="adsimple-121283491">
                Why do we use Google Analytics on our website?
            </h3>
            <p>
                The objective of our website is clear: We want to offer you the
                best possible service. Google Analytics’ statistics and data
                help us with reaching this goal.
            </p>
            <p>
                Statistically evaluated data give us a clear picture of the
                strengths and weaknesses of our website. On the one hand, we can
                optimise our page in a way, that makes it easier to be found by
                interested people on Google. On the other hand, the data helps
                us to get a better understanding of you as our visitor.
                Therefore, we can very accurately find out what we must improve
                on our website, in order to offer you the best possible service.
                The analysis of that data also enables us to carry out our
                advertising and marketing measures in a more individual and more
                cost-effective way. After all, it only makes sense to show our
                products and services exclusively to people who are interested
                in them.
            </p>
            <h3 class="adsimple-121283491">
                What data gets stored by Google Analytics?
            </h3>
            <p>
                With the aid of a tracking code, Google Analytics creates a
                random, unique ID which is connected to your browser cookie.
                That way, Google Analytics recognises you as a new user. The
                next time you visit our site, you will be recognised as a
                “recurring” user. All data that is collected gets saved together
                with this very user ID. Only this is how it is made possible for
                us to evaluate and analyse pseudonymous user profiles.
            </p>
            <p>
                Your interactions on our website are measures by tags such as
                cookies and app instance IDs. Interactions are all kinds of
                actions that you perform on our website. If you are also using
                other Google systems (such as a Google Account), data generated
                by Google Analytics can be linked with third-party cookies.
                Google does not pass on any Google Analytics data, unless we as
                the website owners authorise it. In case it is required by law,
                exceptions can occur.
            </p>
            <p>The following cookies are used by Google Analytics:</p>
            <p>
                <strong class="adsimple-121283491">Name:</strong>
                _ga
                <br />
                <strong class="adsimple-121283491">Value:</strong>
                2.1326744211.152121283491-5
                <br />
                <strong class="adsimple-121283491">Purpose:</strong>
                By deafault, analytics.js uses the cookie _ga, to save the user
                ID. It generally serves the purpose of differenciating between
                website visitors.
                <br />
                <strong class="adsimple-121283491">Expiration date:</strong>
                After 2 years
            </p>
            <p>
                <strong class="adsimple-121283491">Name:</strong>
                _gid
                <br />
                <strong class="adsimple-121283491">Value:</strong>
                2.1687193234.152121283491-1
                <br />
                <strong class="adsimple-121283491">Purpose:</strong>
                This cookie also serves the purpose of differentiating between
                website users
                <br />
                <strong class="adsimple-121283491">Expiration date:</strong>
                After 24 hours
            </p>
            <p>
                <strong class="adsimple-121283491">Name:</strong>
                _gat_gtag_UA_
                <br />
                <strong class="adsimple-121283491">Value:</strong>
                1
                <br />
                <strong class="adsimple-121283491">Verwendungszweck:</strong>
                It is used for decreasing the demand rate. If Google Analytics
                is provided via Google Tag Manager, this cookie gets the name
                _dc_gtm_ .
                <br />
                <strong class="adsimple-121283491">Expiration date:</strong>
                After 1 minute
            </p>
            <p>
                <strong class="adsimple-121283491">Name:</strong>
                AMP_TOKEN
                <br />
                <strong class="adsimple-121283491">Value:</strong>
                No information
                <br />
                <strong class="adsimple-121283491">Purpose:</strong>
                This cookie has a token which is used to retrieve the user ID by
                the AMP Client ID Service. Other possible values suggest a
                logoff, a request or an error.
                <br />
                <strong class="adsimple-121283491">Expiration date:</strong>
                After 30 seconds up to one year
            </p>
            <p>
                <strong class="adsimple-121283491">Name:</strong>
                __utma
                <br />
                <strong class="adsimple-121283491">Value:</strong>
                1564498958.1564498958.1564498958.1
                <br />
                <strong class="adsimple-121283491">Purpose:</strong>
                With this cookie your behaviour on the website can be tracked
                and the site performance can be measured. The cookie is updated
                every time the information is sent to Google Analytics.
                <br />
                <strong class="adsimple-121283491">Expiration date:</strong>
                After 2 years
            </p>
            <p>
                <strong class="adsimple-121283491">Name:</strong>
                __utmt
                <br />
                <strong class="adsimple-121283491">Value:</strong>
                1
                <br />
                <strong class="adsimple-121283491">Purpose:</strong>
                Just like _gat_gtag_UA_ this cookie is used for keeping the
                requirement rate in check.
                <br />
                <strong class="adsimple-121283491">Expiration date:</strong>
                Afer 10 minutes
            </p>
            <p>
                <strong class="adsimple-121283491">Name:</strong>
                __utmb
                <br />
                <strong class="adsimple-121283491">Value:</strong>
                3.10.1564498958
                <br />
                <strong class="adsimple-121283491">Purpose:</strong>
                This cookie is used to determine new sessions. It is updated
                every time new data or information gets sent to Google
                Analytics.
                <br />
                <strong class="adsimple-121283491">Expiration date:</strong>
                After 30 minutes
            </p>
            <p>
                <strong class="adsimple-121283491">Name:</strong>
                __utmc
                <br />
                <strong class="adsimple-121283491">Value:</strong>
                167421564
                <br />
                <strong class="adsimple-121283491">Purpose:</strong>
                This cookie is used to determine new sessions for recurring
                visitors. It is therefore a session cookie, and only stays saved
                until you close the browser again.
                <br />
                <strong class="adsimple-121283491">Expiration date:</strong>
                After closing the browser
            </p>
            <p>
                <strong class="adsimple-121283491">Name:</strong>
                __utmz
                <br />
                <strong class="adsimple-121283491">Value:</strong>
                m|utmccn=(referral)|utmcmd=referral|utmcct=/
                <br />
                <strong class="adsimple-121283491">Purpose:</strong>
                This cookie is used to identify the source of our website’s
                visitor number. This means, that the cookie saves information on
                where you came to our website from. This could be another site
                or an advertisement.
                <br />
                <strong class="adsimple-121283491">Expiration date:</strong>
                After 6 months
            </p>
            <p>
                <strong class="adsimple-121283491">Name:</strong>
                __utmv
                <br />
                <strong class="adsimple-121283491">Value:</strong>
                No information
                <br />
                <strong class="adsimple-121283491">Purpose:</strong>
                The cookie is used to store custom user data. It gets updated
                whenever information is sent to Google Analytics.
                <br />
                <strong class="adsimple-121283491">Expiration date:</strong>
                After 2 years
            </p>
            <p>
                <strong class="adsimple-121283491">Note:</strong>
                This list is by no means exhaustive, since Google are repeatedly
                changing the use of their cookies.
            </p>
            <p>
                Below we will give you an overview of the most important data
                that can be evaluated by Google Analytics:
            </p>
            <p>
                <strong class="adsimple-121283491">Heatmaps:</strong>
                Google creates so-called Heatmaps an. These Heatmaps make it
                possible to see the exact areas you click on, so we can get
                information on what routes you make on our website.
            </p>
            <p>
                <strong class="adsimple-121283491">Session duration:</strong>
                Google calls the time you spend on our website without leaving
                it session duration. Whenever you are inactive for 20 minutes,
                the session ends automatically.
            </p>
            <p>
                <strong class="adsimple-121283491">Bounce rate</strong>
                If you only look at one page of our website and then leave our
                website again, it is called a bounce.
            </p>
            <p>
                <strong class="adsimple-121283491">Account creation:</strong>
                If you create an account or make an order on our website, Google
                Analytics collects this data.
            </p>
            <p>
                <strong class="adsimple-121283491">IP-Address:</strong>
                The IP address is only shown in a shortened form, to make it
                impossible to clearly allocate it.
            </p>
            <p>
                <strong class="adsimple-121283491">Location:</strong>
                Your approximate location and the country you are in can be
                defined by the IP address. This process is called IP location
                determination.
            </p>
            <p>
                <strong class="adsimple-121283491">
                    Technical information:
                </strong>
                Information about your browser type, your internet provider and
                your screen resolution are called technical information.
            </p>
            <p>
                <strong class="adsimple-121283491">Source:</strong>
                Both, Google Analytics as well as ourselves, are interested what
                website or what advertisement led you to our site.
            </p>
            <p>
                Further possibly stored data includes contact data, potential
                reviews, playing media (e.g. when you play a video on our site),
                sharing of contents via social media or adding our site to your
                favourites. This list is not exhaustive and only serves as
                general guidance on Google Analytics’ data retention.
            </p>
            <h3 class="adsimple-121283491">
                How long and where is the data saved?
            </h3>
            <p>
                Google has servers across the globe. Most of them are in America
                and therefore your data is mainly saved on American servers.
                Here you can read detailed information on where Google’s data
                centres are located:
                <a
                    class="adsimple-121283491"
                    href="https://www.google.com/about/datacenters/inside/locations/?hl=en"
                    target="_blank"
                    rel="noopener"
                >
                    https://www.google.com/about/datacenters/inside/locations/?hl=en
                </a>
            </p>
            <p>
                Your data is allocated to various physical data mediums. This
                has the advantage of allowing to retrieve the data faster, and
                of protecting it better from manipulation. Every Google data
                centre has respective emergency programs for your data. Hence,
                in case of a hardware failure at Google or a server error due to
                natural disasters, the risk for a service interruption stays
                relatively low.
            </p>
            <p>
                Google Analytics has a 26 months standardised period of
                retaining your user data. After this time, your user data is
                deleted. However, we have the possibility to choose the
                retention period of user data ourselves. There are the following
                five options:
            </p>
            <ul class="adsimple-121283491">
                <li class="adsimple-121283491">Deletion after 14 months</li>
                <li class="adsimple-121283491">Deletion after 26 months</li>
                <li class="adsimple-121283491">Deletion after 38 months</li>
                <li class="adsimple-121283491">Deletion after 50 months</li>
                <li class="adsimple-121283491">No automatical deletion</li>
            </ul>
            <p>
                As soon as the chosen period is expired, the data is deleted
                once a month. This retention period applies to any of your data
                which is linked to cookies, user identification and
                advertisement IDs (e.g. cookies of the DoubleClick domain). Any
                report results are based on aggregated information and are
                stored independently of any user data. Aggregated information is
                a merge of individual data into a single and bigger unit.
            </p>
            <h3 class="adsimple-121283491">
                How can I delete my data or prevent data retention?
            </h3>
            <p>
                Under the provisions of the European Union’s data protection
                law, you have the right to obtain information on your data and
                to update, delete or restrict it. With the help of a browser add
                on that can deactivate Google Analytics’ JavaScript (ga.js,
                analytics.js, dc.js), you can prevent Google Analytics from
                using your data. You can download this add on at
                <a
                    class="adsimple-121283491"
                    href="https://tools.google.com/dlpage/gaoptout?hl=en-GB"
                    target="_blank"
                    rel="noopener"
                >
                    https://tools.google.com/dlpage/gaoptout?hl=en-GB
                </a>
                . Please consider that this add on can only deactivate any data
                collection by Google Analytics.
            </p>
            <p>
                Should you generally want to deactivate, delete or manage all
                cookies (independently of Google Analytics), you can use one of
                the guides that are available for any browser:
            </p>
            <p>
                <a
                    class="adsimple-121283491"
                    href="https://support.google.com/chrome/answer/95647?tid=121283491"
                    target="_blank"
                    rel="noopener"
                >
                    Chrome: Clear, enable and manage cookies in Chrome
                </a>
            </p>
            <p>
                <a
                    class="adsimple-121283491"
                    href="https://support.apple.com/en-gb/guide/safari/sfri11471/mac?tid=121283491"
                    target="_blank"
                    rel="noopener"
                >
                    Safari: Manage cookies and website data in Safari
                </a>
            </p>
            <p>
                <a
                    class="adsimple-121283491"
                    href=" https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox?tid=121283491"
                    target="_blank"
                    rel="noopener"
                >
                    Firefox: Clear cookies and site data in Firefox
                </a>
            </p>
            <p>
                <a
                    class="adsimple-121283491"
                    href=" https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies?tid=121283491"
                    target="_blank"
                    rel="noopener"
                >
                    Internet Explorer: Delete and manage cookies
                </a>
            </p>
            <p>
                <a
                    class="adsimple-121283491"
                    href=" https://support.microsoft.com/en-gb/help/4027947/microsoft-edge-delete-cookies?tid=121283491"
                    target="_blank"
                    rel="noopener"
                >
                    Microsoft Edge: Delete cookies in Microsoft Edge
                </a>
            </p>
            <p>
                Google Analytics is an active participant of the EU-U.S. Privacy
                Shield Framework, which regulates correct and save transfer of
                personal data.
                <br />
                You can find more information on this at
                <a
                    class="adsimple-121283491"
                    href="https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI"
                    target="_blank"
                    rel="follow noopener"
                >
                    https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&tid=121283491
                </a>
                . We hope we were able to make you more familiar with the most
                important information on Google Analytics’ data processing. If
                you want to learn more about the tracking service, we recommend
                both of the following links:
                <a
                    class="adsimple-121283491"
                    href="https://marketingplatform.google.com/about/analytics/terms/gb/"
                    target="_blank"
                    rel="noopener"
                >
                    https://marketingplatform.google.com/about/analytics/terms/gb/
                </a>
                and
                <a
                    class="adsimple-121283491"
                    href="https://support.google.com/analytics/answer/6004245?hl=en"
                    target="_blank"
                    rel="noopener"
                >
                    https://support.google.com/analytics/answer/6004245?hl=en
                </a>
                .
            </p>
            <h2
                id="google-analytics-ip-anonymisierung-en"
                class="adsimple-121283491"
            >
                Google Analytics IP Anonymisation
            </h2>
            <p>
                We implemented Google Analytics’ IP address anonymisation to
                this website. Google developed this function, so this website
                can comply with the applicable privacy laws and the local data
                protection authorities’ recommendations, should they prohibit
                the retention of any full IP addresses.
                <br />
                The anonymisation or masking of IP addresses takes place, as
                soon as they reach Google Analytics’ data collection network,
                but before the data would be saved or processed.
            </p>
            <p>
                You can find more information on IP anonymisation at
                <a
                    class="adsimple-121283491"
                    href="https://support.google.com/analytics/answer/2763052?hl=en"
                    target="_blank"
                    rel="noopener"
                >
                    https://support.google.com/analytics/answer/2763052?hl=en
                </a>
                .
            </p>
            <h2
                id="google-analytics-berichte-zu-demografischen-merkmalen-und-interessen-en"
                class="adsimple-121283491"
            >
                Google Analytics Reports on demographic characteristics and
                interests
            </h2>
            <p>
                We have turned on Google Analytics’ functions for advertising
                reports. These reports on demographic characteristics and
                interests contain details about age, gender and interests.
                Through them we can get a better picture of our users – without
                being able to allocate any data to individual persons. You can
                learn more about advertising functions at
                <a
                    class="adsimple-121283491"
                    href="https://support.google.com/analytics/answer/3450482?hl=en&amp%3Butm_id=ad"
                    target="_blank"
                    rel="noopener"
                >
                    auf
                    https://support.google.com/analytics/answer/3450482?hl=en&amp;%3Butm_id=ad
                </a>
                .
            </p>
            <p>
                You can terminate the use of your Google Account's activities
                and information in “Ads Settings” at
                <a
                    class="adsimple-121283491"
                    href="https://adssettings.google.com/authenticated"
                >
                    https://adssettings.google.com/authenticated
                </a>
                via a checkbox.
            </p>
            <h2
                id="google-analytics-deaktivierungslink-en"
                class="adsimple-121283491"
            >
                Google Analytics Deactivation Link
            </h2>
            <p>
                By clicking on the following
                <strong class="adsimple-121283491">deactivation link</strong>
                you can prevent Google from tracking your further visits.
                Caution: The deletion of cookies, the use of your browser's
                incognito/private mode or the use of a different browser may
                lead to your data being collected again.
            </p>
            <p>
                <a
                    class="adsimple-121283491 gaoo-opt-out google-analytics-opt-out"
                    href="javascript:gaoop_analytics_optout();"
                >
                    deactivate Google Analytics
                </a>
            </p>
            <h2
                id="google-analytics-zusatz-zur-datenverarbeitung-en"
                class="adsimple-121283491"
            >
                Google Analytics' Data Processing Amendment
            </h2>
            <p>
                By accepting the amendment on data processing in Google
                Analytics, we entered a contract with Google concerning the use
                of Google Analytics.
            </p>
            <p>
                You can find out more about the amendment on data processing for
                Google Analytics here:
                <a
                    class="adsimple-121283491"
                    href="https://support.google.com/analytics/answer/3379636?hl=en&utm_id=ad"
                    target="_blank"
                    rel="noopener"
                >
                    https://support.google.com/analytics/answer/3379636?hl=en&utm_id=ad
                </a>
            </p>
            <h2
                id="google-analytics-google-signale-datenschutzerklaerung-en"
                class="adsimple-121283491"
            >
                Google Analytics Google Signals Privacy Policy
            </h2>
            <p>
                We have activated Google signals in Google Analytics. Through
                this, any existing Google Analytics functions (advertising
                reports, remarketing, cross-device reports and reports on
                interests and demographic characteristics) are updated, to
                result in the summary and anonymisation of your data, should you
                have permitted personalised ads in your Google Account.
            </p>
            <p>
                The special aspect of this is that it involves cross-device
                tracking. That means your data can be analysed across multiple
                devices. Through the activation of Google signals, data is
                collected and linked to the Google account. For example, it
                enables Google to recognise when you look at a product on a
                smartphone and later buy the product on a laptop. Due to
                activating Google signals, we can start cross-device remarketing
                campaigns, which would otherwise not be possible to this extent.
                Remarketing means, that we can show you our products and
                services across other websites as well.
            </p>
            <p>
                Moreover, further visitor data such as location, search history,
                YouTube history and data about your actions on our website are
                collected in Google Analytics. As a result, we receive improved
                advertising reports and more useful information on your
                interests and demographic characteristics. These include your
                age, the language you speak, where you live or what your gender
                is. Certain social criteria such as your job, your marital
                status or your income are also included. All these
                characteristics help Google Analytics to define groups of
                persons or target audiences.
            </p>
            <p>
                Those reports also help us to better assess your behaviour, as
                well as your wishes and interests. As a result, we can optimise
                and customise our products and services for you. By default,
                this data expires after 26 months. Please consider, that this
                data is only collected if you have agreed to personalised
                advertisement in your Google Account. The retained information
                is always exclusively summarised and anonymous data, and never
                any data on individual persons. You can manage or delete this
                data in your Google Account.
            </p>
            <h2
                id="google-tag-manager-datenschutzerklaerung-en"
                class="adsimple-121283491"
            >
                Google Tag Manager Privacy Policy
            </h2>
            <p>
                We use Google Tag Manager by the company Google Inc. (1600
                Amphitheatre Parkway Mountain View, CA 94043, USA) for our
                website.
                <br />
                This Tag Manager is one of Google’s many helpful marketing
                products. With it, we can centrally integrate and manage code
                sections of various tracking tools, that we use on our website.
            </p>
            <p>
                In this privacy statement we will explain in more detail, what
                Google Tag Manager does, why we use it and to what extent your
                data is processed.
            </p>
            <h3 class="adsimple-121283491">What is Google Tag Manager?</h3>
            <p>
                Google Tag Manager is an organising tool with which we can
                integrate and manage website tags centrally and via a user
                interface. Tags are little code sections which e.g. track your
                activities on our website. For this, segments of JavaScript code
                are integrated to our site’s source text. The tags often come
                from Google’s intern products, such as Google Ads or Google
                Analytics, but tags from other companies can also be integrated
                and managed via the manager. Since the tags have different
                tasks, they can collect browser data, feed marketing tools with
                data, embed buttons, set cookies and track users across several
                websites.
            </p>
            <h3 class="adsimple-121283491">
                Why do we use Google Tag Manager for our website?
            </h3>
            <p>
                Everybody knows: Being organised is important! Of course, this
                also applies to maintenance of our website. In order to organise
                and design our website as well as possible for you and anyone
                who is interested in our products and services, we rely on
                various tracking tools, such as Google Analytics.
                <br />
                The collected data shows us what interests you most, which of
                our services we should improve, and which other persons we
                should also display our services to. Furthermore, for this
                tracking to work, we must implement relevant JavaScript Codes to
                our website. While we could theoretically integrate every code
                section of every tracking tool separately into our source text,
                this would take too much time and we would lose overview. This
                is the reason why we use Google Tag Manager. We can easily
                integrate the necessary scripts and manage them from one place.
                Additionally, Google Tag Manager’s user interface is easy to
                operate, and requires no programming skills. Therefore, we can
                easily keep order in our jungle of tags.
            </p>
            <h3 class="adsimple-121283491">
                What data is saved by Google Tag Manager?
            </h3>
            <p>
                Tag Manager itself is a domain that neither uses cookies nor
                stores data. It merely functions as an “administrator“ of
                implemented tags. Data is collected by the individual tags of
                the different web analysis tools. Therefore, in Google Tag
                Manager the data is sent to the individual tracking tools and
                does not get saved.
            </p>
            <p>
                However, with the integrated tags of different web analysis
                tools such as Google Analytics, this is quite different.
                Depending on the analysis tool used, various data on your
                internet behaviour is collected, stored and processed with the
                help of cookies. Please read our texts on data protection for
                more information on the articular analysis and tracking tools we
                use on our website.
            </p>
            <p>
                We allowed Google via the account settings for the Tag Manager
                to receive anonymised data from us. However, this exclusively
                refers to the use of our Tag Manager and not to your data, which
                are saved via code sections. We allow Google and others, to
                receive selected data in anonymous form. Therefore, we agree to
                the anonymised transfer of our website data. However, even after
                extensive research we could not find out what summarised and
                anonymous data it is exactly that gets transmitted. What we do
                know is that Google deleted any info that could identify our
                website. Google combines the data with hundreds of other
                anonymous website data and creates user trends as part of
                benchmarking measures. Benchmarking is a process of comparing a
                company’s results with the ones of competitors. As a result,
                processes can be optimised based on the collected information.
            </p>
            <h3 class="adsimple-121283491">
                How long and where is the data saved?
            </h3>
            <p>
                When Google stores data, this is done on Google’s own servers.
                These servers are located all over the world, with most of them
                being in America. At
                <a
                    class="adsimple-121283491"
                    href="https://www.google.com/about/datacenters/inside/locations/?hl=en"
                    target="_blank"
                    rel="noopener"
                >
                    https://www.google.com/about/datacenters/inside/locations/?hl=en
                </a>
                you can read in detail where Google’s servers are.
            </p>
            <p>
                In our individual data protection texts on the different tools
                you can find out how long the respective tracking tools save
                your data.
            </p>
            <h3 class="adsimple-121283491">
                How can I delete my data or prevent data retention?
            </h3>
            <p>
                Google Tag Manager itself does not set any cookies but manages
                different tracking websites’ tags. In our data protection texts
                on the different tracking tools you can find detailed
                information on how you can delete or manage your data.
            </p>
            <p>
                Google actively participates in the EU-U.S. Privacy Shield
                Framework, which regulates safe transfer of personal data. You
                can find more information at
                <a
                    class="adsimple-121283491"
                    href="https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI"
                    target="_blank"
                    rel="noopener"
                >
                    https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&tid=121283491
                </a>
                . If you want to learn more about Google Tag Manager, we
                recommend you to read
                <a
                    class="adsimple-121283491"
                    href="https://marketingplatform.google.com/intl/en_uk/about/tag-manager/"
                    target="_blank"
                    rel="noopener"
                >
                    https://marketingplatform.google.com/intl/en_uk/about/tag-manager/
                </a>
                .
            </p>
            <h2
                id="eingebettete-social-media-elemente-datenschutzerklaerung-en"
                class="adsimple-121283491"
            >
                Embedded Social Media elements Privacy Policy
            </h2>
            <p>
                We have embedded elements from social media services on our
                website, to display pictures, videos and texts. By visiting
                pages that present such elements, data is transferred from your
                browser to the respective social media service, where it is
                stored. We do not have access to this data.
                <br />
                The following links lead to the respective social media
                services’ sites, where you can find a declaration on how they
                handle your data:
            </p>
            <ul class="adsimple-121283491">
                <li class="adsimple-121283491">
                    Instagram Data Policy:
                    <a
                        class="adsimple-121283491"
                        href="https://help.instagram.com/519522125107875?tid=121283491"
                        target="_blank"
                        rel="noopener"
                    >
                        https://help.instagram.com/519522125107875
                    </a>
                </li>
                <li class="adsimple-121283491">
                    For YouTube, the Google Privacy Policy applies:
                    <a
                        class="adsimple-121283491"
                        href="https://policies.google.com/privacy?hl=en-GB&tid=121283491"
                        target="_blank"
                        rel="noopener"
                    >
                        https://policies.google.com/privacy?hl=en-GB
                    </a>
                </li>
                <li class="adsimple-121283491">
                    Facebook Data Policy:
                    <a
                        class="adsimple-121283491"
                        href="https://www.facebook.com/about/privacy?tid=121283491"
                        target="_blank"
                        rel="noopener"
                    >
                        https://www.facebook.com/about/privacy
                    </a>
                </li>
                <li class="adsimple-121283491">
                    Twitter Privacy Policy:
                    <a
                        class="adsimple-121283491"
                        href="https://twitter.com/en/privacy?tid=121283491"
                        target="_blank"
                        rel="noopener"
                    >
                        https://twitter.com/en/privacy
                    </a>
                </li>
            </ul>
            <p style="margin-top: 15px">
                Source: Created with the Datenschutz Generator by
                <a
                    href="https://www.adsimple.at/"
                    title="AdSimple® Online Marketing and Webdesign"
                    rel="follow"
                    target="_blank"
                >
                    AdSimple®
                </a>
                in cooperation with
                <a href="https://www.bauguide.at/" target="_blank" rel="follow">
                    bauguide.at
                </a>
            </p>
        </div>
    </div>
</template>

<script lang="ts">
export default defineNuxtComponent({
    name: 'ImprintPage',
    head() {
        return {
            title: 'Impressum',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Impressum/Imprint of Raphael Bernhart',
                },
            ],
        };
    },
    mounted() {
        if (this.$route.path.slice(0, 3) === '/en') {
            setTimeout(() => {
                this.scrollToEnglishVersion();
            }, 500);
        }
    },
    methods: {
        scrollToEnglishVersion() {
            const el = document.querySelector('#english-version');
            const { lenis } = useLenis();

            lenis.value.scrollTo(el, {
                duration: 3,
                easing: (x: number) => {
                    return x < 0.5
                        ? 8 * x * x * x * x
                        : 1 - Math.pow(-2 * x + 2, 4) / 2;
                },
            });
        },
    },
});
</script>

<style scoped>
h1 {
    font-size: 4rem;
    font-weight: bold;
    margin: 50px 0 25px 0 !important;
}
h2 {
    font-size: 2.2rem;
    font-weight: bold;
    margin: 40px 0 20px 0 !important;
}
h3 {
    font-size: 1.8rem;
    font-weight: bold;
    margin: 30px 0 15px 0 !important;
}
h4 {
    font-size: 1.5rem;
    font-weight: bold;
    margin: 25px 0 15px 0 !important;
}
h5 {
    font-size: 1.2rem;
    font-weight: bold;
    margin: 20px 0 10px 0 !important;
}
h6 {
    font-size: 1rem;
    font-weight: bold;
    margin: 15px 0 10px 0 !important;
}
a {
    font-weight: 500;
    /* font-style: italic; */
    text-decoration: underline;
}
p {
    line-height: 1.6;
}
</style>
